var items = {
  "block.minecraft.acacia_button": "Акациев бутон",
  "block.minecraft.acacia_door": "Акациева врата",
  "block.minecraft.acacia_fence": "Акациева ограда",
  "block.minecraft.acacia_fence_gate": "Акациева порта",
  "block.minecraft.acacia_hanging_sign": "Акациева висяща табела",
  "block.minecraft.acacia_leaves": "Акациеви листа",
  "block.minecraft.acacia_log": "Акациев дънер",
  "block.minecraft.acacia_planks": "Акациеви дъски",
  "block.minecraft.acacia_pressure_plate": "Акациева претегляща сигнална плоча",
  "block.minecraft.acacia_sapling": "Акациева фиданка",
  "block.minecraft.acacia_shelf": "Акациев рафт",
  "block.minecraft.acacia_sign": "Акациева табела",
  "block.minecraft.acacia_slab": "Акациева плоча",
  "block.minecraft.acacia_stairs": "Акациеви стъпала",
  "block.minecraft.acacia_trapdoor": "Акациев люк",
  "block.minecraft.acacia_wall_hanging_sign": "Висяща на стена Акациева табела",
  "block.minecraft.acacia_wall_sign": "Акациева табела на стена",
  "block.minecraft.acacia_wood": "Акациева дървесина",
  "block.minecraft.activator_rail": "Активираща релса",
  "block.minecraft.air": "Въздух",
  "block.minecraft.allium": "Лук",
  "block.minecraft.amethyst_block": "Блок от аметист",
  "block.minecraft.amethyst_cluster": "Аметистов клъстер",
  "block.minecraft.ancient_debris": "Древни отломки",
  "block.minecraft.andesite": "Андезит",
  "block.minecraft.andesite_slab": "Плоча от андезит",
  "block.minecraft.andesite_stairs": "Стъпала от андезит",
  "block.minecraft.andesite_wall": "Стена от андезит",
  "block.minecraft.anvil": "Наковалня",
  "block.minecraft.attached_melon_stem": "Прикрепено динено стъбло",
  "block.minecraft.attached_pumpkin_stem": "Прикрепено тиквено стъбло",
  "block.minecraft.azalea": "Азалия",
  "block.minecraft.azalea_leaves": "Азалиеви листа",
  "block.minecraft.azure_bluet": "Лазурна метличина",
  "block.minecraft.bamboo": "Бамбук",
  "block.minecraft.bamboo_block": "Бамбуков блок",
  "block.minecraft.bamboo_button": "Бамбуков бутон",
  "block.minecraft.bamboo_door": "Бамбукова врата",
  "block.minecraft.bamboo_fence": "Бамбукова ограда",
  "block.minecraft.bamboo_fence_gate": "Бамбукова порта",
  "block.minecraft.bamboo_hanging_sign": "Бамбукова висяща табела",
  "block.minecraft.bamboo_mosaic": "Бамбукова мозайка",
  "block.minecraft.bamboo_mosaic_slab": "Бамбукова мозаечна плоча",
  "block.minecraft.bamboo_mosaic_stairs": "Бамбукови мозаечни стъпала",
  "block.minecraft.bamboo_planks": "Бамбукови дъски",
  "block.minecraft.bamboo_pressure_plate": "Бамбукова сигнална плоча",
  "block.minecraft.bamboo_sapling": "Бамбуков кълн",
  "block.minecraft.bamboo_shelf": "Бамбуков рафт",
  "block.minecraft.bamboo_sign": "Бамбукова табела",
  "block.minecraft.bamboo_slab": "Бамбукова плоча",
  "block.minecraft.bamboo_stairs": "Бамбукови стъпала",
  "block.minecraft.bamboo_trapdoor": "Бамбуков люк",
  "block.minecraft.bamboo_wall_hanging_sign": "Висяща на стена Бамбукова табела",
  "block.minecraft.bamboo_wall_sign": "Бамбукова стенна табела",
  "block.minecraft.banner.base.black": "Напълно черен плат",
  "block.minecraft.banner.base.blue": "Напълно син плат",
  "block.minecraft.banner.base.brown": "Напълно кафяв плат",
  "block.minecraft.banner.base.cyan": "Напълно синьо-зелен плат",
  "block.minecraft.banner.base.gray": "Напълно сив плат",
  "block.minecraft.banner.base.green": "Напълно зелен плат",
  "block.minecraft.banner.base.light_blue": "Напълно светлосин плат",
  "block.minecraft.banner.base.light_gray": "Напълно светлосив плат",
  "block.minecraft.banner.base.lime": "Напълно жълто-зелен плат",
  "block.minecraft.banner.base.magenta": "Напълно пурпурен плат",
  "block.minecraft.banner.base.orange": "Напълно оранжев плат",
  "block.minecraft.banner.base.pink": "Напълно розов плат",
  "block.minecraft.banner.base.purple": "Напълно лилав плат",
  "block.minecraft.banner.base.red": "Напълно червен плат",
  "block.minecraft.banner.base.white": "Напълно бял плат",
  "block.minecraft.banner.base.yellow": "Напълно жълт плат",
  "block.minecraft.banner.border.black": "Черна рамка",
  "block.minecraft.banner.border.blue": "Синя рамка",
  "block.minecraft.banner.border.brown": "Кафява рамка",
  "block.minecraft.banner.border.cyan": "Синьозелена рамка",
  "block.minecraft.banner.border.gray": "Сива рамка",
  "block.minecraft.banner.border.green": "Зелена рамка",
  "block.minecraft.banner.border.light_blue": "Светлосиня рамка",
  "block.minecraft.banner.border.light_gray": "Светлосива рамка",
  "block.minecraft.banner.border.lime": "Жълто-зелена рамка",
  "block.minecraft.banner.border.magenta": "Пурпурна рамка",
  "block.minecraft.banner.border.orange": "Оранжева рамка",
  "block.minecraft.banner.border.pink": "Розова рамка",
  "block.minecraft.banner.border.purple": "Лилава рамка",
  "block.minecraft.banner.border.red": "Червена рамка",
  "block.minecraft.banner.border.white": "Бяла рамка",
  "block.minecraft.banner.border.yellow": "Жълта рамка",
  "block.minecraft.banner.bricks.black": "Черен зид",
  "block.minecraft.banner.bricks.blue": "Син зид",
  "block.minecraft.banner.bricks.brown": "Кафяв зид",
  "block.minecraft.banner.bricks.cyan": "Синьозелен зид",
  "block.minecraft.banner.bricks.gray": "Сив зид",
  "block.minecraft.banner.bricks.green": "Зелен зид",
  "block.minecraft.banner.bricks.light_blue": "Светлосин зид",
  "block.minecraft.banner.bricks.light_gray": "Светлосив зид",
  "block.minecraft.banner.bricks.lime": "Жълто-зелен зид",
  "block.minecraft.banner.bricks.magenta": "Пурпурен зид",
  "block.minecraft.banner.bricks.orange": "Оранжев зид",
  "block.minecraft.banner.bricks.pink": "Розов зид",
  "block.minecraft.banner.bricks.purple": "Лилав зид",
  "block.minecraft.banner.bricks.red": "Червен зид",
  "block.minecraft.banner.bricks.white": "Бял зид",
  "block.minecraft.banner.bricks.yellow": "Жълт зид",
  "block.minecraft.banner.circle.black": "Черен кръг",
  "block.minecraft.banner.circle.blue": "Син кръг",
  "block.minecraft.banner.circle.brown": "Кафяв кръг",
  "block.minecraft.banner.circle.cyan": "Синьозелен кръг",
  "block.minecraft.banner.circle.gray": "Сив кръг",
  "block.minecraft.banner.circle.green": "Зелен кръг",
  "block.minecraft.banner.circle.light_blue": "Светлосин кръг",
  "block.minecraft.banner.circle.light_gray": "Светлосив кръг",
  "block.minecraft.banner.circle.lime": "Жълто-зелен кръг",
  "block.minecraft.banner.circle.magenta": "Пурпурен кръг",
  "block.minecraft.banner.circle.orange": "Оранжев кръг",
  "block.minecraft.banner.circle.pink": "Розов кръг",
  "block.minecraft.banner.circle.purple": "Лилав кръг",
  "block.minecraft.banner.circle.red": "Червен кръг",
  "block.minecraft.banner.circle.white": "Бял кръг",
  "block.minecraft.banner.circle.yellow": "Жълт кръг",
  "block.minecraft.banner.creeper.black": "Черна фигура на крийпър",
  "block.minecraft.banner.creeper.blue": "Синя фигура на крийпър",
  "block.minecraft.banner.creeper.brown": "Кафява фигура на крийпър",
  "block.minecraft.banner.creeper.cyan": "Синьозелена фигура на крийпър",
  "block.minecraft.banner.creeper.gray": "Сива фигура на крийпър",
  "block.minecraft.banner.creeper.green": "Зелена фигура на крийпър",
  "block.minecraft.banner.creeper.light_blue": "Светлосиня фигура на крийпър",
  "block.minecraft.banner.creeper.light_gray": "Светлосива фигура на крийпър",
  "block.minecraft.banner.creeper.lime": "Жълто-зелена фигура на Creeper",
  "block.minecraft.banner.creeper.magenta": "Пурпурна фигура на крийпър",
  "block.minecraft.banner.creeper.orange": "Оранжева фигура на крийпър",
  "block.minecraft.banner.creeper.pink": "Розова фигура на крийпър",
  "block.minecraft.banner.creeper.purple": "Лилава фигура на крийпър",
  "block.minecraft.banner.creeper.red": "Червена фигура на крийпър",
  "block.minecraft.banner.creeper.white": "Бяла фигура на крийпър",
  "block.minecraft.banner.creeper.yellow": "Жълта фигура на крийпър",
  "block.minecraft.banner.cross.black": "Черен андреевски кръст",
  "block.minecraft.banner.cross.blue": "Син андреевски кръст",
  "block.minecraft.banner.cross.brown": "Кафяв андреевски кръст",
  "block.minecraft.banner.cross.cyan": "Синьозелен андреевски кръст",
  "block.minecraft.banner.cross.gray": "Сив андреевски кръст",
  "block.minecraft.banner.cross.green": "Зелен андреевски кръст",
  "block.minecraft.banner.cross.light_blue": "Светлосин андреевски кръст",
  "block.minecraft.banner.cross.light_gray": "Светлосив андреевски кръст",
  "block.minecraft.banner.cross.lime": "Жълто-зелен андреевски кръст",
  "block.minecraft.banner.cross.magenta": "Пурпурен андреевски кръст",
  "block.minecraft.banner.cross.orange": "Оранжев андреевски кръст",
  "block.minecraft.banner.cross.pink": "Розов андреевски кръст",
  "block.minecraft.banner.cross.purple": "Лилав андреевски кръст",
  "block.minecraft.banner.cross.red": "Червен андреевски кръст",
  "block.minecraft.banner.cross.white": "Бял андреевски кръст",
  "block.minecraft.banner.cross.yellow": "Жълт андреевски кръст",
  "block.minecraft.banner.curly_border.black": "Черна назъбена рамка",
  "block.minecraft.banner.curly_border.blue": "Синя назъбена рамка",
  "block.minecraft.banner.curly_border.brown": "Кафява назъбена рамка",
  "block.minecraft.banner.curly_border.cyan": "Синьозелена назъбена рамка",
  "block.minecraft.banner.curly_border.gray": "Сива назъбена рамка",
  "block.minecraft.banner.curly_border.green": "Зелена назъбена рамка",
  "block.minecraft.banner.curly_border.light_blue": "Светлосиня назъбена рамка",
  "block.minecraft.banner.curly_border.light_gray": "Светлосива назъбена рамка",
  "block.minecraft.banner.curly_border.lime": "Жълто-зелена назъбена рамка",
  "block.minecraft.banner.curly_border.magenta": "Пурпурна назъбена рамка",
  "block.minecraft.banner.curly_border.orange": "Оранжева назъбена рамка",
  "block.minecraft.banner.curly_border.pink": "Розова назъбена рамка",
  "block.minecraft.banner.curly_border.purple": "Лилава назъбена рамка",
  "block.minecraft.banner.curly_border.red": "Червена назъбена рамка",
  "block.minecraft.banner.curly_border.white": "Бяла назъбена рамка",
  "block.minecraft.banner.curly_border.yellow": "Жълта назъбена рамка",
  "block.minecraft.banner.diagonal_left.black": "Черно скосяване наляво",
  "block.minecraft.banner.diagonal_left.blue": "Синьо скосяване наляво",
  "block.minecraft.banner.diagonal_left.brown": "Кафяво скосяване наляво",
  "block.minecraft.banner.diagonal_left.cyan": "Синьозелено скосяване наляво",
  "block.minecraft.banner.diagonal_left.gray": "Сиво скосяване наляво",
  "block.minecraft.banner.diagonal_left.green": "Зелено скосяване наляво",
  "block.minecraft.banner.diagonal_left.light_blue": "Светлосиньо скосяване наляво",
  "block.minecraft.banner.diagonal_left.light_gray": "Светлосиво скосяване наляво",
  "block.minecraft.banner.diagonal_left.lime": "Жълто-зелено скосяване наляво",
  "block.minecraft.banner.diagonal_left.magenta": "Пурпурно скосяване наляво",
  "block.minecraft.banner.diagonal_left.orange": "Оранжево скосяване наляво",
  "block.minecraft.banner.diagonal_left.pink": "Розово скосяване наляво",
  "block.minecraft.banner.diagonal_left.purple": "Лилаво скосяване наляво",
  "block.minecraft.banner.diagonal_left.red": "Червено скосяване наляво",
  "block.minecraft.banner.diagonal_left.white": "Бяло скосяване наляво",
  "block.minecraft.banner.diagonal_left.yellow": "Жълто скосяване наляво",
  "block.minecraft.banner.diagonal_right.black": "Черно скосяване",
  "block.minecraft.banner.diagonal_right.blue": "Синьо скосяване",
  "block.minecraft.banner.diagonal_right.brown": "Кафяво скосяване",
  "block.minecraft.banner.diagonal_right.cyan": "Синьозелено скосяване",
  "block.minecraft.banner.diagonal_right.gray": "Сиво скосяване",
  "block.minecraft.banner.diagonal_right.green": "Зелено скосяване",
  "block.minecraft.banner.diagonal_right.light_blue": "Светлосиньо скосяване",
  "block.minecraft.banner.diagonal_right.light_gray": "Светлосиво скосяване",
  "block.minecraft.banner.diagonal_right.lime": "Жълто-зелено скосяване",
  "block.minecraft.banner.diagonal_right.magenta": "Пурпурно скосяване",
  "block.minecraft.banner.diagonal_right.orange": "Оранжево скосяване",
  "block.minecraft.banner.diagonal_right.pink": "Розово скосяване",
  "block.minecraft.banner.diagonal_right.purple": "Лилаво скосяване",
  "block.minecraft.banner.diagonal_right.red": "Червено скосяване",
  "block.minecraft.banner.diagonal_right.white": "Бяло скосяване",
  "block.minecraft.banner.diagonal_right.yellow": "Жълто скосяване",
  "block.minecraft.banner.diagonal_up_left.black": "Черно обърнато скосяване",
  "block.minecraft.banner.diagonal_up_left.blue": "Синьо обърнато скосяване",
  "block.minecraft.banner.diagonal_up_left.brown": "Кафяво обърнато скосяване",
  "block.minecraft.banner.diagonal_up_left.cyan": "Синьозелено обърнато скосяване",
  "block.minecraft.banner.diagonal_up_left.gray": "Сиво обърнато скосяване",
  "block.minecraft.banner.diagonal_up_left.green": "Зелено обърнато скосяване",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Светлосиньо обърнато скосяване",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Светлосиво обърнато скосяване",
  "block.minecraft.banner.diagonal_up_left.lime": "Жълто-зелено обърнато скосяване",
  "block.minecraft.banner.diagonal_up_left.magenta": "Пурпурно обърнато скосяване",
  "block.minecraft.banner.diagonal_up_left.orange": "Оранжево обърнато скосяване",
  "block.minecraft.banner.diagonal_up_left.pink": "Розово обърнато скосяване",
  "block.minecraft.banner.diagonal_up_left.purple": "Лилаво обърнато скосяване",
  "block.minecraft.banner.diagonal_up_left.red": "Червено обърнато скосяване",
  "block.minecraft.banner.diagonal_up_left.white": "Бяло обърнато скосяване",
  "block.minecraft.banner.diagonal_up_left.yellow": "Жълто обърнато скосяване",
  "block.minecraft.banner.diagonal_up_right.black": "Черно обърнато скосяване наляво",
  "block.minecraft.banner.diagonal_up_right.blue": "Синьо обърнато скосяване наляво",
  "block.minecraft.banner.diagonal_up_right.brown": "Кафяво обърнато скосяване наляво",
  "block.minecraft.banner.diagonal_up_right.cyan": "Синьозелено обърнато скосяване наляво",
  "block.minecraft.banner.diagonal_up_right.gray": "Сиво обърнато скосяване наляво",
  "block.minecraft.banner.diagonal_up_right.green": "Зелено обърнато скосяване наляво",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Светлосиньо обърнато скосяване наляво",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Светлосиво обърнато скосяване наляво",
  "block.minecraft.banner.diagonal_up_right.lime": "Жълто-зелено обърнато скосяване наляво",
  "block.minecraft.banner.diagonal_up_right.magenta": "Пурпурно обърнато скосяване наляво",
  "block.minecraft.banner.diagonal_up_right.orange": "Оранжево обърнато скосяване наляво",
  "block.minecraft.banner.diagonal_up_right.pink": "Розово обърнато скосяване наляво",
  "block.minecraft.banner.diagonal_up_right.purple": "Лилаво обърнато скосяване наляво",
  "block.minecraft.banner.diagonal_up_right.red": "Червено обърнато скосяване наляво",
  "block.minecraft.banner.diagonal_up_right.white": "Бяло обърнато скосяване наляво",
  "block.minecraft.banner.diagonal_up_right.yellow": "Жълто обърнато скосяване наляво",
  "block.minecraft.banner.flow.black": "Черен поток",
  "block.minecraft.banner.flow.blue": "Син поток",
  "block.minecraft.banner.flow.brown": "Кафяв поток",
  "block.minecraft.banner.flow.cyan": "Синьо-зелен поток",
  "block.minecraft.banner.flow.gray": "Сив поток",
  "block.minecraft.banner.flow.green": "Зелен поток",
  "block.minecraft.banner.flow.light_blue": "Светлосин поток",
  "block.minecraft.banner.flow.light_gray": "Светлосив поток",
  "block.minecraft.banner.flow.lime": "Жълто-зелен поток",
  "block.minecraft.banner.flow.magenta": "Пурпурен поток",
  "block.minecraft.banner.flow.orange": "Оранжев поток",
  "block.minecraft.banner.flow.pink": "Розов поток",
  "block.minecraft.banner.flow.purple": "Лилав поток",
  "block.minecraft.banner.flow.red": "Червен поток",
  "block.minecraft.banner.flow.white": "Бял поток",
  "block.minecraft.banner.flow.yellow": "Жълт поток",
  "block.minecraft.banner.flower.black": "Черна фигура на цвете",
  "block.minecraft.banner.flower.blue": "Синя фигура на цвете",
  "block.minecraft.banner.flower.brown": "Кафява фигура на цвете",
  "block.minecraft.banner.flower.cyan": "Синьозелена фигура на цвете",
  "block.minecraft.banner.flower.gray": "Сива фигура на цвете",
  "block.minecraft.banner.flower.green": "Зелена фигура на цвете",
  "block.minecraft.banner.flower.light_blue": "Светлосиня фигура на цвете",
  "block.minecraft.banner.flower.light_gray": "Светлосива фигура на цвете",
  "block.minecraft.banner.flower.lime": "Жълто-зелена фигура на цвете",
  "block.minecraft.banner.flower.magenta": "Пурпурна фигура на цвете",
  "block.minecraft.banner.flower.orange": "Оранжева фигура на цвете",
  "block.minecraft.banner.flower.pink": "Розова фигура на цвете",
  "block.minecraft.banner.flower.purple": "Лилава фигура на цвете",
  "block.minecraft.banner.flower.red": "Червена фигура на цвете",
  "block.minecraft.banner.flower.white": "Бяла фигура на цвете",
  "block.minecraft.banner.flower.yellow": "Жълта фигура на цвете",
  "block.minecraft.banner.globe.black": "Черен Глобус",
  "block.minecraft.banner.globe.blue": "Син Глобус",
  "block.minecraft.banner.globe.brown": "Кафяв глобус",
  "block.minecraft.banner.globe.cyan": "Синьо-зелен глобус",
  "block.minecraft.banner.globe.gray": "Сив Глобус",
  "block.minecraft.banner.globe.green": "Зелен Глобус",
  "block.minecraft.banner.globe.light_blue": "Светлосин Глобус",
  "block.minecraft.banner.globe.light_gray": "Светлосив Глобус",
  "block.minecraft.banner.globe.lime": "Жълто-зелен глобус",
  "block.minecraft.banner.globe.magenta": "Пурпурен Глобус",
  "block.minecraft.banner.globe.orange": "Оранжев Глобус",
  "block.minecraft.banner.globe.pink": "Розов Глобус",
  "block.minecraft.banner.globe.purple": "Лилав Глобус",
  "block.minecraft.banner.globe.red": "Червен Глобус",
  "block.minecraft.banner.globe.white": "Бял Глобус",
  "block.minecraft.banner.globe.yellow": "Жълт Глобус",
  "block.minecraft.banner.gradient.black": "Черна горна преливка",
  "block.minecraft.banner.gradient.blue": "Синя горна преливка",
  "block.minecraft.banner.gradient.brown": "Кафява горна преливка",
  "block.minecraft.banner.gradient.cyan": "Синьозелена горна преливка",
  "block.minecraft.banner.gradient.gray": "Сива горна преливка",
  "block.minecraft.banner.gradient.green": "Зелена горна преливка",
  "block.minecraft.banner.gradient.light_blue": "Светлосиня горна преливка",
  "block.minecraft.banner.gradient.light_gray": "Светлосива горна преливка",
  "block.minecraft.banner.gradient.lime": "Жълто-зелена горна преливка",
  "block.minecraft.banner.gradient.magenta": "Пурпурна горна преливка",
  "block.minecraft.banner.gradient.orange": "Оранжева горна преливка",
  "block.minecraft.banner.gradient.pink": "Розова горна преливка",
  "block.minecraft.banner.gradient.purple": "Лилава горна преливка",
  "block.minecraft.banner.gradient.red": "Червена горна преливка",
  "block.minecraft.banner.gradient.white": "Бяла горна преливка",
  "block.minecraft.banner.gradient.yellow": "Жълта горна преливка",
  "block.minecraft.banner.gradient_up.black": "Черна долна преливка",
  "block.minecraft.banner.gradient_up.blue": "Синя долна преливка",
  "block.minecraft.banner.gradient_up.brown": "Кафява долна преливка",
  "block.minecraft.banner.gradient_up.cyan": "Синьозелена долна преливка",
  "block.minecraft.banner.gradient_up.gray": "Сива долна преливка",
  "block.minecraft.banner.gradient_up.green": "Зелена долна преливка",
  "block.minecraft.banner.gradient_up.light_blue": "Светлосиня долна преливка",
  "block.minecraft.banner.gradient_up.light_gray": "Светлосива долна преливка",
  "block.minecraft.banner.gradient_up.lime": "Жълто-зелена долна преливка",
  "block.minecraft.banner.gradient_up.magenta": "Пурпурна долна преливка",
  "block.minecraft.banner.gradient_up.orange": "Оранжева долна преливка",
  "block.minecraft.banner.gradient_up.pink": "Розова долна преливка",
  "block.minecraft.banner.gradient_up.purple": "Лилава долна преливка",
  "block.minecraft.banner.gradient_up.red": "Червена долна преливка",
  "block.minecraft.banner.gradient_up.white": "Бяла долна преливка",
  "block.minecraft.banner.gradient_up.yellow": "Жълта долна преливка",
  "block.minecraft.banner.guster.black": "Черен Вихър",
  "block.minecraft.banner.guster.blue": "Син Вихър",
  "block.minecraft.banner.guster.brown": "Кафяв Вихър",
  "block.minecraft.banner.guster.cyan": "Синьо-зелен Вихър",
  "block.minecraft.banner.guster.gray": "Сив Вихър",
  "block.minecraft.banner.guster.green": "Зелен Вихър",
  "block.minecraft.banner.guster.light_blue": "Светло син Вихър",
  "block.minecraft.banner.guster.light_gray": "Светло сив Густър",
  "block.minecraft.banner.guster.lime": "Жълто-зелен Густер",
  "block.minecraft.banner.guster.magenta": "Пурпурен Густър",
  "block.minecraft.banner.guster.orange": "Оранжев Густър",
  "block.minecraft.banner.guster.pink": "Розов Густър",
  "block.minecraft.banner.guster.purple": "Лилав Густър",
  "block.minecraft.banner.guster.red": "Червен Густър",
  "block.minecraft.banner.guster.white": "Бял Густър",
  "block.minecraft.banner.guster.yellow": "Жълт Густър",
  "block.minecraft.banner.half_horizontal.black": "Черно горно пресичане",
  "block.minecraft.banner.half_horizontal.blue": "Синьо горно пресичане",
  "block.minecraft.banner.half_horizontal.brown": "Кафяво горно пресичане",
  "block.minecraft.banner.half_horizontal.cyan": "Синьозелено горно пресичане",
  "block.minecraft.banner.half_horizontal.gray": "Сиво горно пресичане",
  "block.minecraft.banner.half_horizontal.green": "Зелено горно пресичане",
  "block.minecraft.banner.half_horizontal.light_blue": "Светлосиньо горно пресичане",
  "block.minecraft.banner.half_horizontal.light_gray": "Светлосиво горно пресичане",
  "block.minecraft.banner.half_horizontal.lime": "Жълто-зелено горно пресичане",
  "block.minecraft.banner.half_horizontal.magenta": "Пурпурно горно пресичане",
  "block.minecraft.banner.half_horizontal.orange": "Оранжево горно пресичане",
  "block.minecraft.banner.half_horizontal.pink": "Розово горно пресичане",
  "block.minecraft.banner.half_horizontal.purple": "Лилаво горно пресичане",
  "block.minecraft.banner.half_horizontal.red": "Червено горно пресичане",
  "block.minecraft.banner.half_horizontal.white": "Бяло горно пресичане",
  "block.minecraft.banner.half_horizontal.yellow": "Жълто горно пресичане",
  "block.minecraft.banner.half_horizontal_bottom.black": "Черно долно пресичане",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Синьо долно пресичане",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Кафяво долно пресичане",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Синьозелено долно пресичане",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Сиво долно пресичане",
  "block.minecraft.banner.half_horizontal_bottom.green": "Зелено долно пресичане",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Светлосиньо долно пресичане",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Светлосиво долно пресичане",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Жълто-зелено долно пресичане",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Пурпурно долно пресичане",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Оранжево долно пресичане",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Розово долно пресичане",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Лилаво долно пресичане",
  "block.minecraft.banner.half_horizontal_bottom.red": "Червено долно пресичане",
  "block.minecraft.banner.half_horizontal_bottom.white": "Бяло долно пресичане",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Жълто долно пресичане",
  "block.minecraft.banner.half_vertical.black": "Черно дясно разсичане",
  "block.minecraft.banner.half_vertical.blue": "Синьо дясно разсичане",
  "block.minecraft.banner.half_vertical.brown": "Кафяво дясно разсичане",
  "block.minecraft.banner.half_vertical.cyan": "Синьозелено дясно разсичане",
  "block.minecraft.banner.half_vertical.gray": "Сиво дясно разсичане",
  "block.minecraft.banner.half_vertical.green": "Зелено дясно разсичане",
  "block.minecraft.banner.half_vertical.light_blue": "Светлосиньо дясно разсичане",
  "block.minecraft.banner.half_vertical.light_gray": "Светлосиво дясно разсичане",
  "block.minecraft.banner.half_vertical.lime": "Жълто-зелено дясно разсичане",
  "block.minecraft.banner.half_vertical.magenta": "Пурпурно дясно разсичане",
  "block.minecraft.banner.half_vertical.orange": "Оранжево дясно разсичане",
  "block.minecraft.banner.half_vertical.pink": "Розово дясно разсичане",
  "block.minecraft.banner.half_vertical.purple": "Лилаво дясно разсичане",
  "block.minecraft.banner.half_vertical.red": "Червено дясно разсичане",
  "block.minecraft.banner.half_vertical.white": "Бяло дясно разсичане",
  "block.minecraft.banner.half_vertical.yellow": "Жълто дясно разсичане",
  "block.minecraft.banner.half_vertical_right.black": "Черно ляво разсичане",
  "block.minecraft.banner.half_vertical_right.blue": "Синьо ляво разсичане",
  "block.minecraft.banner.half_vertical_right.brown": "Кафяво ляво разсичане",
  "block.minecraft.banner.half_vertical_right.cyan": "Синьозелено ляво разсичане",
  "block.minecraft.banner.half_vertical_right.gray": "Сиво ляво разсичане",
  "block.minecraft.banner.half_vertical_right.green": "Зелено ляво разсичане",
  "block.minecraft.banner.half_vertical_right.light_blue": "Светлосиньо ляво разсичане",
  "block.minecraft.banner.half_vertical_right.light_gray": "Светлосиво ляво разсичане",
  "block.minecraft.banner.half_vertical_right.lime": "Жълто-зелено ляво разсичане",
  "block.minecraft.banner.half_vertical_right.magenta": "Пурпурно ляво разсичане",
  "block.minecraft.banner.half_vertical_right.orange": "Оранжево ляво разсичане",
  "block.minecraft.banner.half_vertical_right.pink": "Розово ляво разсичане",
  "block.minecraft.banner.half_vertical_right.purple": "Лилаво ляво разсичане",
  "block.minecraft.banner.half_vertical_right.red": "Червено ляво разсичане",
  "block.minecraft.banner.half_vertical_right.white": "Бяло ляво разсичане",
  "block.minecraft.banner.half_vertical_right.yellow": "Жълто ляво разсичане",
  "block.minecraft.banner.mojang.black": "Черно нещо",
  "block.minecraft.banner.mojang.blue": "Синьо нещо",
  "block.minecraft.banner.mojang.brown": "Кафяво нещо",
  "block.minecraft.banner.mojang.cyan": "Синьозелено нещо",
  "block.minecraft.banner.mojang.gray": "Сиво нещо",
  "block.minecraft.banner.mojang.green": "Зелено нещо",
  "block.minecraft.banner.mojang.light_blue": "Светлосиньо нещо",
  "block.minecraft.banner.mojang.light_gray": "Светлосиво нещо",
  "block.minecraft.banner.mojang.lime": "Жълто-зелено нещо",
  "block.minecraft.banner.mojang.magenta": "Пурпурно нещо",
  "block.minecraft.banner.mojang.orange": "Оранжево нещо",
  "block.minecraft.banner.mojang.pink": "Розово нещо",
  "block.minecraft.banner.mojang.purple": "Лилаво нещо",
  "block.minecraft.banner.mojang.red": "Червено нещо",
  "block.minecraft.banner.mojang.white": "Бяло нещо",
  "block.minecraft.banner.mojang.yellow": "Жълто нещо",
  "block.minecraft.banner.piglin.black": "Черна муцуна",
  "block.minecraft.banner.piglin.blue": "Синя муцуна",
  "block.minecraft.banner.piglin.brown": "Кафява муцуна",
  "block.minecraft.banner.piglin.cyan": "Синьо-зелена муцуна",
  "block.minecraft.banner.piglin.gray": "Сива муцуна",
  "block.minecraft.banner.piglin.green": "Зелена муцуна",
  "block.minecraft.banner.piglin.light_blue": "Светлосиня муцуна",
  "block.minecraft.banner.piglin.light_gray": "Светлосива муцуна",
  "block.minecraft.banner.piglin.lime": "Жълто-зелена муцуна",
  "block.minecraft.banner.piglin.magenta": "Пурпурна муцуна",
  "block.minecraft.banner.piglin.orange": "Оранжева муцуна",
  "block.minecraft.banner.piglin.pink": "Розова муцуна",
  "block.minecraft.banner.piglin.purple": "Лилава муцуна",
  "block.minecraft.banner.piglin.red": "Червена муцуна",
  "block.minecraft.banner.piglin.white": "Бяла муцуна",
  "block.minecraft.banner.piglin.yellow": "Жълта муцуна",
  "block.minecraft.banner.rhombus.black": "Черен ромб",
  "block.minecraft.banner.rhombus.blue": "Син ромб",
  "block.minecraft.banner.rhombus.brown": "Кафяв ромб",
  "block.minecraft.banner.rhombus.cyan": "Синьозелен ромб",
  "block.minecraft.banner.rhombus.gray": "Сив ромб",
  "block.minecraft.banner.rhombus.green": "Зелен ромб",
  "block.minecraft.banner.rhombus.light_blue": "Светлосин ромб",
  "block.minecraft.banner.rhombus.light_gray": "Светлосив  ромб",
  "block.minecraft.banner.rhombus.lime": "Жълто-зелен ромб",
  "block.minecraft.banner.rhombus.magenta": "Пурпурен ромб",
  "block.minecraft.banner.rhombus.orange": "Оранжев ромб",
  "block.minecraft.banner.rhombus.pink": "Розов ромб",
  "block.minecraft.banner.rhombus.purple": "Лилав ромб",
  "block.minecraft.banner.rhombus.red": "Червен ромб",
  "block.minecraft.banner.rhombus.white": "Бял ромб",
  "block.minecraft.banner.rhombus.yellow": "Жълт ромб",
  "block.minecraft.banner.skull.black": "Черна фигура на череп",
  "block.minecraft.banner.skull.blue": "Синя фигура на череп",
  "block.minecraft.banner.skull.brown": "Кафява фигура на череп",
  "block.minecraft.banner.skull.cyan": "Синьозелена фигура на череп",
  "block.minecraft.banner.skull.gray": "Сива фигура на череп",
  "block.minecraft.banner.skull.green": "Зелена фигура на череп",
  "block.minecraft.banner.skull.light_blue": "Светлосиня фигура на череп",
  "block.minecraft.banner.skull.light_gray": "Светлосива фигура на череп",
  "block.minecraft.banner.skull.lime": "Жълто-зелена фигура на череп",
  "block.minecraft.banner.skull.magenta": "Пурпурна фигура на череп",
  "block.minecraft.banner.skull.orange": "Оранжева фигура на череп",
  "block.minecraft.banner.skull.pink": "Розова фигура на череп",
  "block.minecraft.banner.skull.purple": "Лилава фигура на череп",
  "block.minecraft.banner.skull.red": "Червена фигура на череп",
  "block.minecraft.banner.skull.white": "Бяла фигура на череп",
  "block.minecraft.banner.skull.yellow": "Жълта фигура на череп",
  "block.minecraft.banner.small_stripes.black": "Черни хоризонтални ивици",
  "block.minecraft.banner.small_stripes.blue": "Сини хоризонтални ивици",
  "block.minecraft.banner.small_stripes.brown": "Кафяви хоризонтални ивици",
  "block.minecraft.banner.small_stripes.cyan": "Синьозелени хоризонтални ивици",
  "block.minecraft.banner.small_stripes.gray": "Сиви хоризонтални ивици",
  "block.minecraft.banner.small_stripes.green": "Зелени хоризонтални ивици",
  "block.minecraft.banner.small_stripes.light_blue": "Светлосини хоризонтални ивици",
  "block.minecraft.banner.small_stripes.light_gray": "Светлосиви хоризонтални ивици",
  "block.minecraft.banner.small_stripes.lime": "Жълто-зелени хоризонтални ивици",
  "block.minecraft.banner.small_stripes.magenta": "Пурпурни хоризонтални ивици",
  "block.minecraft.banner.small_stripes.orange": "Оранжеви хоризонтални ивици",
  "block.minecraft.banner.small_stripes.pink": "Розови хоризонтални ивици",
  "block.minecraft.banner.small_stripes.purple": "Лилави хоризонтални ивици",
  "block.minecraft.banner.small_stripes.red": "Червени хоризонтални ивици",
  "block.minecraft.banner.small_stripes.white": "Бели хоризонтални ивици",
  "block.minecraft.banner.small_stripes.yellow": "Жълти хоризонтални ивици",
  "block.minecraft.banner.square_bottom_left.black": "Черен десен долен кантон",
  "block.minecraft.banner.square_bottom_left.blue": "Син десен долен кантон",
  "block.minecraft.banner.square_bottom_left.brown": "Кафяв десен долен кантон",
  "block.minecraft.banner.square_bottom_left.cyan": "Синьозелен десен долен кантон",
  "block.minecraft.banner.square_bottom_left.gray": "Сив десен долен кантон",
  "block.minecraft.banner.square_bottom_left.green": "Зелен десен долен кантон",
  "block.minecraft.banner.square_bottom_left.light_blue": "Светлосин десен долен кантон",
  "block.minecraft.banner.square_bottom_left.light_gray": "Светлосив десен долен кантон",
  "block.minecraft.banner.square_bottom_left.lime": "Жълто-зелен десен долен кантон",
  "block.minecraft.banner.square_bottom_left.magenta": "Пурпурен десен долен кантон",
  "block.minecraft.banner.square_bottom_left.orange": "Оранжев десен долен кантон",
  "block.minecraft.banner.square_bottom_left.pink": "Розов десен долен кантон",
  "block.minecraft.banner.square_bottom_left.purple": "Лилав десен долен кантон",
  "block.minecraft.banner.square_bottom_left.red": "Червен десен долен кантон",
  "block.minecraft.banner.square_bottom_left.white": "Бял десен долен кантон",
  "block.minecraft.banner.square_bottom_left.yellow": "Жълт десен долен кантон",
  "block.minecraft.banner.square_bottom_right.black": "Черен ляв долен кантон",
  "block.minecraft.banner.square_bottom_right.blue": "Син ляв долен кантон",
  "block.minecraft.banner.square_bottom_right.brown": "Кафяв ляв долен кантон",
  "block.minecraft.banner.square_bottom_right.cyan": "Синьозелен ляв долен кантон",
  "block.minecraft.banner.square_bottom_right.gray": "Сив ляв долен кантон",
  "block.minecraft.banner.square_bottom_right.green": "Зелен ляв долен кантон",
  "block.minecraft.banner.square_bottom_right.light_blue": "Светлосин ляв долен кантон",
  "block.minecraft.banner.square_bottom_right.light_gray": "Светлосив ляв долен кантон",
  "block.minecraft.banner.square_bottom_right.lime": "Жълто-зелен ляв долен кантон",
  "block.minecraft.banner.square_bottom_right.magenta": "Пурпурен ляв долен кантон",
  "block.minecraft.banner.square_bottom_right.orange": "Оранжев ляв долен кантон",
  "block.minecraft.banner.square_bottom_right.pink": "Розов ляв долен кантон",
  "block.minecraft.banner.square_bottom_right.purple": "Лилав ляв долен кантон",
  "block.minecraft.banner.square_bottom_right.red": "Червен ляв долен кантон",
  "block.minecraft.banner.square_bottom_right.white": "Бял ляв долен кантон",
  "block.minecraft.banner.square_bottom_right.yellow": "Жълт ляв долен кантон",
  "block.minecraft.banner.square_top_left.black": "Черен десен горен кантон",
  "block.minecraft.banner.square_top_left.blue": "Син десен горен кантон",
  "block.minecraft.banner.square_top_left.brown": "Кафяв десен горен кантон",
  "block.minecraft.banner.square_top_left.cyan": "Синьозелен десен горен кантон",
  "block.minecraft.banner.square_top_left.gray": "Сив десен горен кантон",
  "block.minecraft.banner.square_top_left.green": "Зелен десен горен кантон",
  "block.minecraft.banner.square_top_left.light_blue": "Светлосин десен горен кантон",
  "block.minecraft.banner.square_top_left.light_gray": "Светлосив десен горен кантон",
  "block.minecraft.banner.square_top_left.lime": "Жълто-зелен десен горен кантон",
  "block.minecraft.banner.square_top_left.magenta": "Пурпурен десен горен кантон",
  "block.minecraft.banner.square_top_left.orange": "Оранжев десен горен кантон",
  "block.minecraft.banner.square_top_left.pink": "Розов десен горен кантон",
  "block.minecraft.banner.square_top_left.purple": "Лилав десен горен кантон",
  "block.minecraft.banner.square_top_left.red": "Червен десен горен кантон",
  "block.minecraft.banner.square_top_left.white": "Бял десен горен кантон",
  "block.minecraft.banner.square_top_left.yellow": "Жълт десен горен кантон",
  "block.minecraft.banner.square_top_right.black": "Черен ляв горен кантон",
  "block.minecraft.banner.square_top_right.blue": "Син ляв горен кантон",
  "block.minecraft.banner.square_top_right.brown": "Кафяв ляв горен кантон",
  "block.minecraft.banner.square_top_right.cyan": "Синьозелен ляв горен кантон",
  "block.minecraft.banner.square_top_right.gray": "Сив ляв горен кантон",
  "block.minecraft.banner.square_top_right.green": "Зелен ляв горен кантон",
  "block.minecraft.banner.square_top_right.light_blue": "Светлосин ляв горен кантон",
  "block.minecraft.banner.square_top_right.light_gray": "Светлосив ляв горен кантон",
  "block.minecraft.banner.square_top_right.lime": "Жълто-зелен ляв горен кантон",
  "block.minecraft.banner.square_top_right.magenta": "Пурпурен ляв горен кантон",
  "block.minecraft.banner.square_top_right.orange": "Оранжев ляв горен кантон",
  "block.minecraft.banner.square_top_right.pink": "Розов ляв горен кантон",
  "block.minecraft.banner.square_top_right.purple": "Лилав ляв горен кантон",
  "block.minecraft.banner.square_top_right.red": "Червен ляв горен кантон",
  "block.minecraft.banner.square_top_right.white": "Бял ляв горен кантон",
  "block.minecraft.banner.square_top_right.yellow": "Жълт ляв горен кантон",
  "block.minecraft.banner.straight_cross.black": "Черен кръст",
  "block.minecraft.banner.straight_cross.blue": "Син кръст",
  "block.minecraft.banner.straight_cross.brown": "Кафяв кръст",
  "block.minecraft.banner.straight_cross.cyan": "Синьозелен кръст",
  "block.minecraft.banner.straight_cross.gray": "Сив кръст",
  "block.minecraft.banner.straight_cross.green": "Зелен кръст",
  "block.minecraft.banner.straight_cross.light_blue": "Светлосин кръст",
  "block.minecraft.banner.straight_cross.light_gray": "Светлосив кръст",
  "block.minecraft.banner.straight_cross.lime": "Жълто-зелен кръст",
  "block.minecraft.banner.straight_cross.magenta": "Пурпурен кръст",
  "block.minecraft.banner.straight_cross.orange": "Оранжев кръст",
  "block.minecraft.banner.straight_cross.pink": "Розов кръст",
  "block.minecraft.banner.straight_cross.purple": "Лилав кръст",
  "block.minecraft.banner.straight_cross.red": "Червен кръст",
  "block.minecraft.banner.straight_cross.white": "Бял кръст",
  "block.minecraft.banner.straight_cross.yellow": "Жълт кръст",
  "block.minecraft.banner.stripe_bottom.black": "Черна хоризонтална лента",
  "block.minecraft.banner.stripe_bottom.blue": "Синя хоризонтална лента",
  "block.minecraft.banner.stripe_bottom.brown": "Кафява хоризонтална лента",
  "block.minecraft.banner.stripe_bottom.cyan": "Синьозелена хоризонтална лента",
  "block.minecraft.banner.stripe_bottom.gray": "Сива хоризонтална лента",
  "block.minecraft.banner.stripe_bottom.green": "Зелена хоризонтална лента",
  "block.minecraft.banner.stripe_bottom.light_blue": "Светлосиня хоризонтална лента",
  "block.minecraft.banner.stripe_bottom.light_gray": "Светлосива хоризонтална лента",
  "block.minecraft.banner.stripe_bottom.lime": "Жълто-зелена хоризонтална лента",
  "block.minecraft.banner.stripe_bottom.magenta": "Пурпурна хоризонтална лента",
  "block.minecraft.banner.stripe_bottom.orange": "Оранжева хоризонтална лента",
  "block.minecraft.banner.stripe_bottom.pink": "Розова хоризонтална лента",
  "block.minecraft.banner.stripe_bottom.purple": "Лилава хоризонтална лента",
  "block.minecraft.banner.stripe_bottom.red": "Червена хоризонтална лента",
  "block.minecraft.banner.stripe_bottom.white": "Бяла хоризонтална лента",
  "block.minecraft.banner.stripe_bottom.yellow": "Жълта хоризонтална лента",
  "block.minecraft.banner.stripe_center.black": "Черна вертикална лента",
  "block.minecraft.banner.stripe_center.blue": "Синя вертикална лента",
  "block.minecraft.banner.stripe_center.brown": "Кафява вертикална лента",
  "block.minecraft.banner.stripe_center.cyan": "Синьозелена вертикална лента",
  "block.minecraft.banner.stripe_center.gray": "Сива вертикална лента",
  "block.minecraft.banner.stripe_center.green": "Зелена вертикална лента",
  "block.minecraft.banner.stripe_center.light_blue": "Светлосиня вертикална лента",
  "block.minecraft.banner.stripe_center.light_gray": "Светлосива вертикална лента",
  "block.minecraft.banner.stripe_center.lime": "Жълто-зелена вертикална лента",
  "block.minecraft.banner.stripe_center.magenta": "Пурпурна вертикална лента",
  "block.minecraft.banner.stripe_center.orange": "Оранжева вертикална лента",
  "block.minecraft.banner.stripe_center.pink": "Розова вертикална лента",
  "block.minecraft.banner.stripe_center.purple": "Лилава вертикална лента",
  "block.minecraft.banner.stripe_center.red": "Червена вертикална лента",
  "block.minecraft.banner.stripe_center.white": "Бяла вертикална лента",
  "block.minecraft.banner.stripe_center.yellow": "Жълта вертикална лента",
  "block.minecraft.banner.stripe_downleft.black": "Черен диагонал от дясно на ляво",
  "block.minecraft.banner.stripe_downleft.blue": "Син диагонал от дясно на ляво",
  "block.minecraft.banner.stripe_downleft.brown": "Кафяв диагонал от дясно на ляво",
  "block.minecraft.banner.stripe_downleft.cyan": "Синьозелен диагонал от дясно на ляво",
  "block.minecraft.banner.stripe_downleft.gray": "Сив диагонал от дясно на ляво",
  "block.minecraft.banner.stripe_downleft.green": "Зелен диагонал от дясно на ляво",
  "block.minecraft.banner.stripe_downleft.light_blue": "Светлосин диагонал от дясно на ляво",
  "block.minecraft.banner.stripe_downleft.light_gray": "Светлосив диагонал от дясно на ляво",
  "block.minecraft.banner.stripe_downleft.lime": "Жълто-зелен диагонал от дясно на ляво",
  "block.minecraft.banner.stripe_downleft.magenta": "Пурпурен диагонал от дясно на ляво",
  "block.minecraft.banner.stripe_downleft.orange": "Оранжев диагонал от дясно на ляво",
  "block.minecraft.banner.stripe_downleft.pink": "Розов диагонал от дясно на ляво",
  "block.minecraft.banner.stripe_downleft.purple": "Лилав диагонал от дясно на ляво",
  "block.minecraft.banner.stripe_downleft.red": "Червен диагонал от дясно на ляво",
  "block.minecraft.banner.stripe_downleft.white": "Бял диагонал от дясно на ляво",
  "block.minecraft.banner.stripe_downleft.yellow": "Жълт диагонал от дясно на ляво",
  "block.minecraft.banner.stripe_downright.black": "Черен диагонал от ляво на дясно",
  "block.minecraft.banner.stripe_downright.blue": "Син диагонал от ляво на дясно",
  "block.minecraft.banner.stripe_downright.brown": "Кафяв диагонал от ляво на дясно",
  "block.minecraft.banner.stripe_downright.cyan": "Синьозелен диагонал от ляво на дясно",
  "block.minecraft.banner.stripe_downright.gray": "Сив диагонал от ляво на дясно",
  "block.minecraft.banner.stripe_downright.green": "Зелен диагонал от ляво на дясно",
  "block.minecraft.banner.stripe_downright.light_blue": "Светлосин диагонал от ляво на дясно",
  "block.minecraft.banner.stripe_downright.light_gray": "Светлосив диагонал от ляво на дясно",
  "block.minecraft.banner.stripe_downright.lime": "Жълто-зелен диагонал от ляво на дясно",
  "block.minecraft.banner.stripe_downright.magenta": "Пурпурен диагонал от ляво на дясно",
  "block.minecraft.banner.stripe_downright.orange": "Оранжев диагонал от ляво на дясно",
  "block.minecraft.banner.stripe_downright.pink": "Розов диагонал от ляво на дясно",
  "block.minecraft.banner.stripe_downright.purple": "Лилав диагонал от ляво на дясно",
  "block.minecraft.banner.stripe_downright.red": "Червен диагонал от ляво на дясно",
  "block.minecraft.banner.stripe_downright.white": "Бял диагонал от ляво на дясно",
  "block.minecraft.banner.stripe_downright.yellow": "Жълт диагонал от ляво на дясно",
  "block.minecraft.banner.stripe_left.black": "Черна дясна лента",
  "block.minecraft.banner.stripe_left.blue": "Синя дясна лента",
  "block.minecraft.banner.stripe_left.brown": "Кафява дясна лента",
  "block.minecraft.banner.stripe_left.cyan": "Синьозелена дясна лента",
  "block.minecraft.banner.stripe_left.gray": "Сива дясна лента",
  "block.minecraft.banner.stripe_left.green": "Зелена дясна лента",
  "block.minecraft.banner.stripe_left.light_blue": "Светлосиня дясна лента",
  "block.minecraft.banner.stripe_left.light_gray": "Светлосива дясна лента",
  "block.minecraft.banner.stripe_left.lime": "Жълто-зелена дясна лента",
  "block.minecraft.banner.stripe_left.magenta": "Пурпурна дясна лента",
  "block.minecraft.banner.stripe_left.orange": "Оранжева дясна лента",
  "block.minecraft.banner.stripe_left.pink": "Розова дясна лента",
  "block.minecraft.banner.stripe_left.purple": "Лилава дясна лента",
  "block.minecraft.banner.stripe_left.red": "Червена дясна лента",
  "block.minecraft.banner.stripe_left.white": "Бяла дясна лента",
  "block.minecraft.banner.stripe_left.yellow": "Жълта дясна лента",
  "block.minecraft.banner.stripe_middle.black": "Черна хоризонтална лента",
  "block.minecraft.banner.stripe_middle.blue": "Синя хоризонтална лента",
  "block.minecraft.banner.stripe_middle.brown": "Кафява хоризонтална лента",
  "block.minecraft.banner.stripe_middle.cyan": "Синьозелена хоризонтална лента",
  "block.minecraft.banner.stripe_middle.gray": "Сива хоризонтална лента",
  "block.minecraft.banner.stripe_middle.green": "Зелена хоризонтална лента",
  "block.minecraft.banner.stripe_middle.light_blue": "Светлосиня хоризонтална лента",
  "block.minecraft.banner.stripe_middle.light_gray": "Светлосива хоризонтална лента",
  "block.minecraft.banner.stripe_middle.lime": "Жълто-зелена хоризонтална лента",
  "block.minecraft.banner.stripe_middle.magenta": "Пурпурна хоризонтална лента",
  "block.minecraft.banner.stripe_middle.orange": "Оранжева хоризонтална лента",
  "block.minecraft.banner.stripe_middle.pink": "Розова хоризонтална лента",
  "block.minecraft.banner.stripe_middle.purple": "Лилава хоризонтална лента",
  "block.minecraft.banner.stripe_middle.red": "Червена хоризонтална лента",
  "block.minecraft.banner.stripe_middle.white": "Бяла хоризонтална лента",
  "block.minecraft.banner.stripe_middle.yellow": "Жълта хоризонтална лента",
  "block.minecraft.banner.stripe_right.black": "Черна лява лента",
  "block.minecraft.banner.stripe_right.blue": "Синя лява лента",
  "block.minecraft.banner.stripe_right.brown": "Кафява лява лента",
  "block.minecraft.banner.stripe_right.cyan": "Синьозелена лява лента",
  "block.minecraft.banner.stripe_right.gray": "Сива лява лента",
  "block.minecraft.banner.stripe_right.green": "Зелена лява лента",
  "block.minecraft.banner.stripe_right.light_blue": "Светлосиня лява лента",
  "block.minecraft.banner.stripe_right.light_gray": "Светлосива лява лента",
  "block.minecraft.banner.stripe_right.lime": "Жълто-зелена лява лента",
  "block.minecraft.banner.stripe_right.magenta": "Пурпурна лява лента",
  "block.minecraft.banner.stripe_right.orange": "Оранжева лява лента",
  "block.minecraft.banner.stripe_right.pink": "Розова лява лента",
  "block.minecraft.banner.stripe_right.purple": "Лилава лява лента",
  "block.minecraft.banner.stripe_right.red": "Червена лява лента",
  "block.minecraft.banner.stripe_right.white": "Бяла лява лента",
  "block.minecraft.banner.stripe_right.yellow": "Жълта лява лента",
  "block.minecraft.banner.stripe_top.black": "Черна горна лента",
  "block.minecraft.banner.stripe_top.blue": "Синя горна лента",
  "block.minecraft.banner.stripe_top.brown": "Кафява горна лента",
  "block.minecraft.banner.stripe_top.cyan": "Синьозелена горна лента",
  "block.minecraft.banner.stripe_top.gray": "Сива горна лента",
  "block.minecraft.banner.stripe_top.green": "Зелена горна лента",
  "block.minecraft.banner.stripe_top.light_blue": "Светлосиня горна лента",
  "block.minecraft.banner.stripe_top.light_gray": "Светлосива горна лента",
  "block.minecraft.banner.stripe_top.lime": "Жълто-зелена горна лента",
  "block.minecraft.banner.stripe_top.magenta": "Пурпурна горна лента",
  "block.minecraft.banner.stripe_top.orange": "Оранжева горна лента",
  "block.minecraft.banner.stripe_top.pink": "Розова горна лента",
  "block.minecraft.banner.stripe_top.purple": "Лилава горна лента",
  "block.minecraft.banner.stripe_top.red": "Червена горна лента",
  "block.minecraft.banner.stripe_top.white": "Бяла горна лента",
  "block.minecraft.banner.stripe_top.yellow": "Жълта горна лента",
  "block.minecraft.banner.triangle_bottom.black": "Черен шеврон",
  "block.minecraft.banner.triangle_bottom.blue": "Син шеврон",
  "block.minecraft.banner.triangle_bottom.brown": "Кафяв шеврон",
  "block.minecraft.banner.triangle_bottom.cyan": "Синьозелен шеврон",
  "block.minecraft.banner.triangle_bottom.gray": "Сив шеврон",
  "block.minecraft.banner.triangle_bottom.green": "Зелен шеврон",
  "block.minecraft.banner.triangle_bottom.light_blue": "Светлосин шеврон",
  "block.minecraft.banner.triangle_bottom.light_gray": "Светлосив шеврон",
  "block.minecraft.banner.triangle_bottom.lime": "Жълто-зелен шеврон",
  "block.minecraft.banner.triangle_bottom.magenta": "Пурпурен шеврон",
  "block.minecraft.banner.triangle_bottom.orange": "Оранжев шеврон",
  "block.minecraft.banner.triangle_bottom.pink": "Розов шеврон",
  "block.minecraft.banner.triangle_bottom.purple": "Лилав шеврон",
  "block.minecraft.banner.triangle_bottom.red": "Червен шеврон",
  "block.minecraft.banner.triangle_bottom.white": "Бял шеврон",
  "block.minecraft.banner.triangle_bottom.yellow": "Жълт шеврон",
  "block.minecraft.banner.triangle_top.black": "Черен обърнат шеврон",
  "block.minecraft.banner.triangle_top.blue": "Син обърнат шеврон",
  "block.minecraft.banner.triangle_top.brown": "Кафяв обърнат шеврон",
  "block.minecraft.banner.triangle_top.cyan": "Синьозелен обърнат шеврон",
  "block.minecraft.banner.triangle_top.gray": "Сив обърнат шеврон",
  "block.minecraft.banner.triangle_top.green": "Зелен обърнат шеврон",
  "block.minecraft.banner.triangle_top.light_blue": "Светлосин обърнат шеврон",
  "block.minecraft.banner.triangle_top.light_gray": "Светлосив обърнат шеврон",
  "block.minecraft.banner.triangle_top.lime": "Жълто-зелен обърнат шеврон",
  "block.minecraft.banner.triangle_top.magenta": "Пурпурен обърнат шеврон",
  "block.minecraft.banner.triangle_top.orange": "Оранжев обърнат шеврон",
  "block.minecraft.banner.triangle_top.pink": "Розов обърнат шеврон",
  "block.minecraft.banner.triangle_top.purple": "Лилав обърнат шеврон",
  "block.minecraft.banner.triangle_top.red": "Червен обърнат шеврон",
  "block.minecraft.banner.triangle_top.white": "Бял обърнат шеврон",
  "block.minecraft.banner.triangle_top.yellow": "Жълт обърнат шеврон",
  "block.minecraft.banner.triangles_bottom.black": "Черни долни зъбци",
  "block.minecraft.banner.triangles_bottom.blue": "Сини долни зъбци",
  "block.minecraft.banner.triangles_bottom.brown": "Кафяви долни зъбци",
  "block.minecraft.banner.triangles_bottom.cyan": "Синьозелени долни зъбци",
  "block.minecraft.banner.triangles_bottom.gray": "Сиви долни зъбци",
  "block.minecraft.banner.triangles_bottom.green": "Зелени долни зъбци",
  "block.minecraft.banner.triangles_bottom.light_blue": "Светлосини долни зъбци",
  "block.minecraft.banner.triangles_bottom.light_gray": "Светлосиви долни зъбци",
  "block.minecraft.banner.triangles_bottom.lime": "Жълто-зелени долни зъбци",
  "block.minecraft.banner.triangles_bottom.magenta": "Пурпурни долни зъбци",
  "block.minecraft.banner.triangles_bottom.orange": "Оранжеви долни зъбци",
  "block.minecraft.banner.triangles_bottom.pink": "Розови долни зъбци",
  "block.minecraft.banner.triangles_bottom.purple": "Лилави долни зъбци",
  "block.minecraft.banner.triangles_bottom.red": "Червени долни зъбци",
  "block.minecraft.banner.triangles_bottom.white": "Бели долни зъбци",
  "block.minecraft.banner.triangles_bottom.yellow": "Жълти долни зъбци",
  "block.minecraft.banner.triangles_top.black": "Черни горни зъбци",
  "block.minecraft.banner.triangles_top.blue": "Сини горни зъбци",
  "block.minecraft.banner.triangles_top.brown": "Кафяви горни зъбци",
  "block.minecraft.banner.triangles_top.cyan": "Синьозелени горни зъбци",
  "block.minecraft.banner.triangles_top.gray": "Сиви горни зъбци",
  "block.minecraft.banner.triangles_top.green": "Зелени горни зъбци",
  "block.minecraft.banner.triangles_top.light_blue": "Светлосини горни зъбци",
  "block.minecraft.banner.triangles_top.light_gray": "Светлосиви горни зъбци",
  "block.minecraft.banner.triangles_top.lime": "Жълто-зелени горни зъбци",
  "block.minecraft.banner.triangles_top.magenta": "Пурпурни горни зъбци",
  "block.minecraft.banner.triangles_top.orange": "Оранжеви горни зъбци",
  "block.minecraft.banner.triangles_top.pink": "Розови горни зъбци",
  "block.minecraft.banner.triangles_top.purple": "Лилави горни зъбци",
  "block.minecraft.banner.triangles_top.red": "Червени горни зъбци",
  "block.minecraft.banner.triangles_top.white": "Бели горни зъбци",
  "block.minecraft.banner.triangles_top.yellow": "Жълти горни зъбци",
  "block.minecraft.barrel": "Буре",
  "block.minecraft.barrier": "Бариера",
  "block.minecraft.basalt": "Базалт",
  "block.minecraft.beacon": "Маяк",
  "block.minecraft.beacon.primary": "Основен ефект",
  "block.minecraft.beacon.secondary": "Вторичен ефект",
  "block.minecraft.bed.no_sleep": "Може да спите само през нощта или по време на бури",
  "block.minecraft.bed.not_safe": "Не можете да спите сега; има чудовища наоколо",
  "block.minecraft.bed.obstructed": "Леглото е възпрепятстванo",
  "block.minecraft.bed.occupied": "Леглото е заето",
  "block.minecraft.bed.too_far_away": "Не можете да спите сега; леглото е твърде далеч",
  "block.minecraft.bedrock": "Основен камък",
  "block.minecraft.bee_nest": "Пчелен кошер",
  "block.minecraft.beehive": "Кошер",
  "block.minecraft.beetroots": "Цвекло",
  "block.minecraft.bell": "Камбана",
  "block.minecraft.big_dripleaf": "Голям паделист",
  "block.minecraft.big_dripleaf_stem": "Стъбло на голям паделист",
  "block.minecraft.birch_button": "Брезов бутон",
  "block.minecraft.birch_door": "Брезова врата",
  "block.minecraft.birch_fence": "Брезова ограда",
  "block.minecraft.birch_fence_gate": "Брезова порта",
  "block.minecraft.birch_hanging_sign": "Брезова висяща табела",
  "block.minecraft.birch_leaves": "Брезови листа",
  "block.minecraft.birch_log": "Брезов дънер",
  "block.minecraft.birch_planks": "Брезови дъски",
  "block.minecraft.birch_pressure_plate": "Брезова претегляща сигнална плоча",
  "block.minecraft.birch_sapling": "Брезова фиданка",
  "block.minecraft.birch_shelf": "Брезов рафт",
  "block.minecraft.birch_sign": "Брезова табела",
  "block.minecraft.birch_slab": "Брезова плоча",
  "block.minecraft.birch_stairs": "Брезови стъпала",
  "block.minecraft.birch_trapdoor": "Брезов люк",
  "block.minecraft.birch_wall_hanging_sign": "Висяща на стена Брезова табела",
  "block.minecraft.birch_wall_sign": "Брезова табела на стена",
  "block.minecraft.birch_wood": "Брезова дървесина",
  "block.minecraft.black_banner": "Черно знаме",
  "block.minecraft.black_bed": "Черно легло",
  "block.minecraft.black_candle": "Черна свещ",
  "block.minecraft.black_candle_cake": "Торта с черна свещ",
  "block.minecraft.black_carpet": "Черен килим",
  "block.minecraft.black_concrete": "Черен бетон",
  "block.minecraft.black_concrete_powder": "Черен цимент",
  "block.minecraft.black_glazed_terracotta": "Черна глазирана теракота",
  "block.minecraft.black_shulker_box": "Черна шулкърова кутия",
  "block.minecraft.black_stained_glass": "Черно стъкло",
  "block.minecraft.black_stained_glass_pane": "Черен стъклен панел",
  "block.minecraft.black_terracotta": "Черна теракота",
  "block.minecraft.black_wool": "Черна вълна",
  "block.minecraft.blackstone": "Черен камък",
  "block.minecraft.blackstone_slab": "Плоча от черен камък",
  "block.minecraft.blackstone_stairs": "Стъпала от черен камък",
  "block.minecraft.blackstone_wall": "Стена от черен камък",
  "block.minecraft.blast_furnace": "Доменна пещ",
  "block.minecraft.blue_banner": "Синьо знаме",
  "block.minecraft.blue_bed": "Синьо легло",
  "block.minecraft.blue_candle": "Синя свещ",
  "block.minecraft.blue_candle_cake": "Торта със синя свещ",
  "block.minecraft.blue_carpet": "Син килим",
  "block.minecraft.blue_concrete": "Син бетон",
  "block.minecraft.blue_concrete_powder": "Син цимент",
  "block.minecraft.blue_glazed_terracotta": "Синя глазирана теракота",
  "block.minecraft.blue_ice": "Ледник",
  "block.minecraft.blue_orchid": "Синя орхидея",
  "block.minecraft.blue_shulker_box": "Синя шулкърова кутия",
  "block.minecraft.blue_stained_glass": "Синьо стъкло",
  "block.minecraft.blue_stained_glass_pane": "Син стъклен панел",
  "block.minecraft.blue_terracotta": "Синя теракота",
  "block.minecraft.blue_wool": "Синя вълна",
  "block.minecraft.bone_block": "Костен блок",
  "block.minecraft.bookshelf": "Рафтове с книги",
  "block.minecraft.brain_coral": "Мозъчен корал",
  "block.minecraft.brain_coral_block": "Блок от мозъчен корал",
  "block.minecraft.brain_coral_fan": "Мозъчен мек корал",
  "block.minecraft.brain_coral_wall_fan": "Мозъчен мек корал на стена",
  "block.minecraft.brewing_stand": "Статив за отвари",
  "block.minecraft.brick_slab": "Тухлена плоча",
  "block.minecraft.brick_stairs": "Тухлени стъпала",
  "block.minecraft.brick_wall": "Тухлена стена",
  "block.minecraft.bricks": "Тухли",
  "block.minecraft.brown_banner": "Кафяво знаме",
  "block.minecraft.brown_bed": "Кафяво легло",
  "block.minecraft.brown_candle": "Кафява свещ",
  "block.minecraft.brown_candle_cake": "Торта с кафява свещ",
  "block.minecraft.brown_carpet": "Кафяв килим",
  "block.minecraft.brown_concrete": "Кафяв бетон",
  "block.minecraft.brown_concrete_powder": "Кафяв цимент",
  "block.minecraft.brown_glazed_terracotta": "Кафява глазирана теракота",
  "block.minecraft.brown_mushroom": "Кафява гъба",
  "block.minecraft.brown_mushroom_block": "Кафяв гъбен блок",
  "block.minecraft.brown_shulker_box": "Кафява шулкърова кутия",
  "block.minecraft.brown_stained_glass": "Кафяво стъкло",
  "block.minecraft.brown_stained_glass_pane": "Кафяв стъклен панел",
  "block.minecraft.brown_terracotta": "Кафява теракота",
  "block.minecraft.brown_wool": "Кафява вълна",
  "block.minecraft.bubble_column": "Мехурчета",
  "block.minecraft.bubble_coral": "Мехурчест корал",
  "block.minecraft.bubble_coral_block": "Блок от мехурчест корал",
  "block.minecraft.bubble_coral_fan": "Мехурчест мек корал",
  "block.minecraft.bubble_coral_wall_fan": "Мехурчест мек корал на стена",
  "block.minecraft.budding_amethyst": "Кристализиращ аметист",
  "block.minecraft.bush": "Храст",
  "block.minecraft.cactus": "Кактус",
  "block.minecraft.cactus_flower": "Кактусово цвете",
  "block.minecraft.cake": "Торта",
  "block.minecraft.calcite": "Калцит",
  "block.minecraft.calibrated_sculk_sensor": "Калибриран скълк сензор",
  "block.minecraft.campfire": "Лагерен огън",
  "block.minecraft.candle": "Свещ",
  "block.minecraft.candle_cake": "Торта със свещ",
  "block.minecraft.carrots": "Моркови",
  "block.minecraft.cartography_table": "Картографска маса",
  "block.minecraft.carved_pumpkin": "Издълбана тиква",
  "block.minecraft.cauldron": "Казан",
  "block.minecraft.cave_air": "Въздух в пещера",
  "block.minecraft.cave_vines": "Пещерни лиани",
  "block.minecraft.cave_vines_plant": "Пещерно лозе растение",
  "block.minecraft.chain": "Верига",
  "block.minecraft.chain_command_block": "Верижен команден блок",
  "block.minecraft.cherry_button": "Черешов бутон",
  "block.minecraft.cherry_door": "Черешова врата",
  "block.minecraft.cherry_fence": "Черешова ограда",
  "block.minecraft.cherry_fence_gate": "Черешова порта",
  "block.minecraft.cherry_hanging_sign": "Черешова висяща табела",
  "block.minecraft.cherry_leaves": "Черешови листа",
  "block.minecraft.cherry_log": "Черешов дънер",
  "block.minecraft.cherry_planks": "Черешови дъски",
  "block.minecraft.cherry_pressure_plate": "Черешова претегляща сигнална плоча",
  "block.minecraft.cherry_sapling": "Черешова фиданка",
  "block.minecraft.cherry_shelf": "Черешов рафт",
  "block.minecraft.cherry_sign": "Черешова табела",
  "block.minecraft.cherry_slab": "Черешова плоча",
  "block.minecraft.cherry_stairs": "Черешови стъпала",
  "block.minecraft.cherry_trapdoor": "Черешов люк",
  "block.minecraft.cherry_wall_hanging_sign": "Висяща на стена черешова табела",
  "block.minecraft.cherry_wall_sign": "Черешова табела на стена",
  "block.minecraft.cherry_wood": "Черешова дървесина",
  "block.minecraft.chest": "Сандък",
  "block.minecraft.chipped_anvil": "Очукана наковалня",
  "block.minecraft.chiseled_bookshelf": "Издялан рафт за книги",
  "block.minecraft.chiseled_copper": "Издялана мед",
  "block.minecraft.chiseled_deepslate": "Дялани шисти",
  "block.minecraft.chiseled_nether_bricks": "Дялани тухли от Недъра",
  "block.minecraft.chiseled_polished_blackstone": "Дялан полиран черен камък",
  "block.minecraft.chiseled_quartz_block": "Изписан кварцов блок",
  "block.minecraft.chiseled_red_sandstone": "Издялан червен пясъчник",
  "block.minecraft.chiseled_resin_bricks": "Дялани тухли от смола",
  "block.minecraft.chiseled_sandstone": "Издялан пясъчник",
  "block.minecraft.chiseled_stone_bricks": "Изписани каменни тухли",
  "block.minecraft.chiseled_tuff": "Дялан туф",
  "block.minecraft.chiseled_tuff_bricks": "Дялани тухли от туф",
  "block.minecraft.chorus_flower": "Припевно цвете",
  "block.minecraft.chorus_plant": "Припевно растение",
  "block.minecraft.clay": "Глина",
  "block.minecraft.closed_eyeblossom": "Затворен очеболец",
  "block.minecraft.coal_block": "Въглищен блок",
  "block.minecraft.coal_ore": "Въглищна руда",
  "block.minecraft.coarse_dirt": "Едра пръст",
  "block.minecraft.cobbled_deepslate": "Калдъръмени шисти",
  "block.minecraft.cobbled_deepslate_slab": "Калдъръмена шистова плоча",
  "block.minecraft.cobbled_deepslate_stairs": "Калдъръмени шистови стъпала",
  "block.minecraft.cobbled_deepslate_wall": "Калдъръмена шистова стена",
  "block.minecraft.cobblestone": "Калдъръмени камъни",
  "block.minecraft.cobblestone_slab": "Плоча от калдъръмени камъни",
  "block.minecraft.cobblestone_stairs": "Стъпала от калдъръмени камъни",
  "block.minecraft.cobblestone_wall": "Калдъръмена стена",
  "block.minecraft.cobweb": "Паяжина",
  "block.minecraft.cocoa": "Какао",
  "block.minecraft.command_block": "Команден блок",
  "block.minecraft.comparator": "Червенокаменен сравнител",
  "block.minecraft.composter": "Компостер",
  "block.minecraft.conduit": "Воден маяк",
  "block.minecraft.copper_bars": "Медни решетки",
  "block.minecraft.copper_block": "Блок от мед",
  "block.minecraft.copper_bulb": "Медна крушка",
  "block.minecraft.copper_chain": "Меднa веригa",
  "block.minecraft.copper_chest": "Меден сандък",
  "block.minecraft.copper_door": "Медна врата",
  "block.minecraft.copper_golem_statue": "Статуя на меден голем",
  "block.minecraft.copper_grate": "Медна решетка",
  "block.minecraft.copper_lantern": "Меден фенер",
  "block.minecraft.copper_ore": "Медна руда",
  "block.minecraft.copper_torch": "Медна факла",
  "block.minecraft.copper_trapdoor": "Меден люк",
  "block.minecraft.copper_wall_torch": "Медна стенна факла",
  "block.minecraft.cornflower": "Синя метличина",
  "block.minecraft.cracked_deepslate_bricks": "Напукани шистови тухли",
  "block.minecraft.cracked_deepslate_tiles": "Напукани сегментирани шисти",
  "block.minecraft.cracked_nether_bricks": "Напукани Nether тухли",
  "block.minecraft.cracked_polished_blackstone_bricks": "Пукнати полирани тухли от черен камък",
  "block.minecraft.cracked_stone_bricks": "Напукани каменни тухли",
  "block.minecraft.crafter": "Създател",
  "block.minecraft.crafting_table": "Работна маса",
  "block.minecraft.creaking_heart": "Скърцащо сърце",
  "block.minecraft.creeper_head": "Глава на крийпър",
  "block.minecraft.creeper_wall_head": "Глава на крийпър на стена",
  "block.minecraft.crimson_button": "Пурпурен бутон",
  "block.minecraft.crimson_door": "Пурпурна врата",
  "block.minecraft.crimson_fence": "Пурпурна ограда",
  "block.minecraft.crimson_fence_gate": "Пурпурна порта",
  "block.minecraft.crimson_fungus": "Пурпурна гъба",
  "block.minecraft.crimson_hanging_sign": "Пурпурна висяща табела",
  "block.minecraft.crimson_hyphae": "Пурпурни хифи",
  "block.minecraft.crimson_nylium": "Пурпурен найлиум",
  "block.minecraft.crimson_planks": "Пурпурни дъски",
  "block.minecraft.crimson_pressure_plate": "Пурпурна сигнална плоча",
  "block.minecraft.crimson_roots": "Пурпурни корени",
  "block.minecraft.crimson_shelf": "Пурпурен рафт",
  "block.minecraft.crimson_sign": "Пурпурна табела",
  "block.minecraft.crimson_slab": "Пурпурна плоча",
  "block.minecraft.crimson_stairs": "Пурпурни стъпала",
  "block.minecraft.crimson_stem": "Пурпурно стъбло",
  "block.minecraft.crimson_trapdoor": "Пурпурен люк",
  "block.minecraft.crimson_wall_hanging_sign": "Висяща на стена Пурпурна табела",
  "block.minecraft.crimson_wall_sign": "Пурпурна стенна табела",
  "block.minecraft.crying_obsidian": "Плачещ Обсидиан",
  "block.minecraft.cut_copper": "Сечена мед",
  "block.minecraft.cut_copper_slab": "Плоча от сечена мед",
  "block.minecraft.cut_copper_stairs": "Стъпала от сечена мед",
  "block.minecraft.cut_red_sandstone": "Плоча от сечен червен пясъчник",
  "block.minecraft.cut_red_sandstone_slab": "Плоча от сечен червен пясъчник",
  "block.minecraft.cut_sandstone": "Сечен пясъчник",
  "block.minecraft.cut_sandstone_slab": "Плоча от сечен пясъчник",
  "block.minecraft.cyan_banner": "Синьозелено знаме",
  "block.minecraft.cyan_bed": "Синьозелено легло",
  "block.minecraft.cyan_candle": "Синьозелена свещ",
  "block.minecraft.cyan_candle_cake": "Торта със синьозелена свещ",
  "block.minecraft.cyan_carpet": "Синьозелен килим",
  "block.minecraft.cyan_concrete": "Синьозелен бетон",
  "block.minecraft.cyan_concrete_powder": "Синьозелен цимент",
  "block.minecraft.cyan_glazed_terracotta": "Синьозелена глазирана теракота",
  "block.minecraft.cyan_shulker_box": "Синьозелена шулкърова кутия",
  "block.minecraft.cyan_stained_glass": "Синьозеленo стъкло",
  "block.minecraft.cyan_stained_glass_pane": "Синьозелен стъклен панел",
  "block.minecraft.cyan_terracotta": "Синьозелена теракота",
  "block.minecraft.cyan_wool": "Синьозелена вълна",
  "block.minecraft.damaged_anvil": "Повредена наковалня",
  "block.minecraft.dandelion": "Глухарче",
  "block.minecraft.dark_oak_button": "Бутон от черен дъб",
  "block.minecraft.dark_oak_door": "Врата от черен дъб",
  "block.minecraft.dark_oak_fence": "Ограда от черен дъб",
  "block.minecraft.dark_oak_fence_gate": "Порта от черен дъб",
  "block.minecraft.dark_oak_hanging_sign": "Висяща табела от черен дъб",
  "block.minecraft.dark_oak_leaves": "Листа от черен дъб",
  "block.minecraft.dark_oak_log": "Дънер от черен дъб",
  "block.minecraft.dark_oak_planks": "Дъски от черен дъб",
  "block.minecraft.dark_oak_pressure_plate": "Претегляща сигнална плоча от черен дъб",
  "block.minecraft.dark_oak_sapling": "Фиданка на черен дъб",
  "block.minecraft.dark_oak_shelf": "Чернодъбов рафт",
  "block.minecraft.dark_oak_sign": "Табела от черен дъб",
  "block.minecraft.dark_oak_slab": "Плоча от черен дъб",
  "block.minecraft.dark_oak_stairs": "Стъпала от черен дъб",
  "block.minecraft.dark_oak_trapdoor": "Люк от черен дъб",
  "block.minecraft.dark_oak_wall_hanging_sign": "Висяща на стена Тъмно дъбова табела",
  "block.minecraft.dark_oak_wall_sign": "Табела от черен дъб на стена",
  "block.minecraft.dark_oak_wood": "Дървесина от черен дъб",
  "block.minecraft.dark_prismarine": "Тъмен призмарин",
  "block.minecraft.dark_prismarine_slab": "Плоча от тъмен призмарин",
  "block.minecraft.dark_prismarine_stairs": "Стъпала от тъмен призмарин",
  "block.minecraft.daylight_detector": "Датчик за дневна светлина",
  "block.minecraft.dead_brain_coral": "Мъртъв мозъчен корал",
  "block.minecraft.dead_brain_coral_block": "Блок от мъртъв мозъчен корал",
  "block.minecraft.dead_brain_coral_fan": "Мъртъв мозъчен мек корал",
  "block.minecraft.dead_brain_coral_wall_fan": "Мъртъв мозъчен мек корал на стена",
  "block.minecraft.dead_bubble_coral": "Мъртъв мехурчест корал",
  "block.minecraft.dead_bubble_coral_block": "Блок от мъртъв мехурчест корал",
  "block.minecraft.dead_bubble_coral_fan": "Мъртъв мехурчест мек корал",
  "block.minecraft.dead_bubble_coral_wall_fan": "Мъртъв мехурчест мек корал на стена",
  "block.minecraft.dead_bush": "Изсъхнал храст",
  "block.minecraft.dead_fire_coral": "Мъртъв огнен корал",
  "block.minecraft.dead_fire_coral_block": "Блок от мъртъв огнен корал",
  "block.minecraft.dead_fire_coral_fan": "Мъртъв огнен мек корал",
  "block.minecraft.dead_fire_coral_wall_fan": "Мъртъв огнен мек корал на стена",
  "block.minecraft.dead_horn_coral": "Мъртъв рогов корал",
  "block.minecraft.dead_horn_coral_block": "Блок от мъртъв рогов корал",
  "block.minecraft.dead_horn_coral_fan": "Мъртъв рогов мек корал",
  "block.minecraft.dead_horn_coral_wall_fan": "Мъртъв рогов мек корал на стена",
  "block.minecraft.dead_tube_coral": "Мъртъв тръбен корал",
  "block.minecraft.dead_tube_coral_block": "Блок от мъртъв тръбен корал",
  "block.minecraft.dead_tube_coral_fan": "Мъртъв тръбен мек корал",
  "block.minecraft.dead_tube_coral_wall_fan": "Мъртъв тръбен мек корал на стена",
  "block.minecraft.decorated_pot": "Украсено гърне",
  "block.minecraft.deepslate": "Шисти",
  "block.minecraft.deepslate_brick_slab": "Плоча от шистови тухли",
  "block.minecraft.deepslate_brick_stairs": "Стъпала от шистови тухли",
  "block.minecraft.deepslate_brick_wall": "Стена от шистови тухли",
  "block.minecraft.deepslate_bricks": "Шистови тухли",
  "block.minecraft.deepslate_coal_ore": "Шистова въглищна руда",
  "block.minecraft.deepslate_copper_ore": "Шистова медна руда",
  "block.minecraft.deepslate_diamond_ore": "Шистова диамантена руда",
  "block.minecraft.deepslate_emerald_ore": "Шистова смарагдова руда",
  "block.minecraft.deepslate_gold_ore": "Шистова златна руда",
  "block.minecraft.deepslate_iron_ore": "Шистова желязна руда",
  "block.minecraft.deepslate_lapis_ore": "Шистова лазуритна руда",
  "block.minecraft.deepslate_redstone_ore": "Шистова червенокаменна руда",
  "block.minecraft.deepslate_tile_slab": "Плоча от сегментирани шисти",
  "block.minecraft.deepslate_tile_stairs": "Стъпала от сегментирани шисти",
  "block.minecraft.deepslate_tile_wall": "Стена от сегментирани шисти",
  "block.minecraft.deepslate_tiles": "Сегментирани шисти",
  "block.minecraft.detector_rail": "Индикаторни релси",
  "block.minecraft.diamond_block": "Диамантен блок",
  "block.minecraft.diamond_ore": "Диамантена руда",
  "block.minecraft.diorite": "Диорит",
  "block.minecraft.diorite_slab": "Плоча от диорит",
  "block.minecraft.diorite_stairs": "Стъпала от диорит",
  "block.minecraft.diorite_wall": "Стена от диорит",
  "block.minecraft.dirt": "Пръст",
  "block.minecraft.dirt_path": "Пътека",
  "block.minecraft.dispenser": "Разпределител",
  "block.minecraft.dragon_egg": "Драконово яйце",
  "block.minecraft.dragon_head": "Глава на дракон",
  "block.minecraft.dragon_wall_head": "Глава на дракон на стена",
  "block.minecraft.dried_ghast": "Изсушен Гаст",
  "block.minecraft.dried_kelp_block": "Блокче от изсушени водорасли",
  "block.minecraft.dripstone_block": "Синтров блок",
  "block.minecraft.dropper": "Изпускател",
  "block.minecraft.emerald_block": "Смарагдов блок",
  "block.minecraft.emerald_ore": "Смарагдова руда",
  "block.minecraft.enchanting_table": "Чародейска маса",
  "block.minecraft.end_gateway": "Портал от Края",
  "block.minecraft.end_portal": "Портал към Края",
  "block.minecraft.end_portal_frame": "Рамка на портал към Края",
  "block.minecraft.end_rod": "Пръчка от Края",
  "block.minecraft.end_stone": "Камък от Края",
  "block.minecraft.end_stone_brick_slab": "Плоча от тухли от Края",
  "block.minecraft.end_stone_brick_stairs": "Стъпала от тухли от Края",
  "block.minecraft.end_stone_brick_wall": "Стена от тухли от Края",
  "block.minecraft.end_stone_bricks": "Тухли от Края",
  "block.minecraft.ender_chest": "Сандък от Края",
  "block.minecraft.exposed_chiseled_copper": "Изложена издялана мед",
  "block.minecraft.exposed_copper": "Изложена мед",
  "block.minecraft.exposed_copper_bars": "Оголени медни решетки",
  "block.minecraft.exposed_copper_bulb": "Изложена медна крушка",
  "block.minecraft.exposed_copper_chain": "Оголена медна верига",
  "block.minecraft.exposed_copper_chest": "Изложен меден сандък",
  "block.minecraft.exposed_copper_door": "Оголена медна врата",
  "block.minecraft.exposed_copper_golem_statue": "Изложена статуя на меден голем",
  "block.minecraft.exposed_copper_grate": "Оголена медна решетка",
  "block.minecraft.exposed_copper_lantern": "Оголен меден фенер",
  "block.minecraft.exposed_copper_trapdoor": "Изложен меден люк",
  "block.minecraft.exposed_cut_copper": "Изложена сечена мед",
  "block.minecraft.exposed_cut_copper_slab": "Изложена плоча от сечена мед",
  "block.minecraft.exposed_cut_copper_stairs": "Изложени стъпала от сечена мед",
  "block.minecraft.exposed_lightning_rod": "Незащитен мълниеотвод",
  "block.minecraft.farmland": "Обработваема земя",
  "block.minecraft.fern": "Папрат",
  "block.minecraft.fire": "Огън",
  "block.minecraft.fire_coral": "Огнен корал",
  "block.minecraft.fire_coral_block": "Блок от огнен корал",
  "block.minecraft.fire_coral_fan": "Огнен мек корал",
  "block.minecraft.fire_coral_wall_fan": "Огнен мек корал на стена",
  "block.minecraft.firefly_bush": "\nСветулка Буш",
  "block.minecraft.fletching_table": "Маса за лъкове",
  "block.minecraft.flower_pot": "Саксия",
  "block.minecraft.flowering_azalea": "Цъфтяща азалия",
  "block.minecraft.flowering_azalea_leaves": "Цъфтящи азалиеви листа",
  "block.minecraft.frogspawn": "Жабешки яйца",
  "block.minecraft.frosted_ice": "Заскрежен лед",
  "block.minecraft.furnace": "Пещ",
  "block.minecraft.gilded_blackstone": "Позлатен черен камък",
  "block.minecraft.glass": "Стъкло",
  "block.minecraft.glass_pane": "Стъклен панел",
  "block.minecraft.glow_lichen": "Светещ лишей",
  "block.minecraft.glowstone": "Сияещ камък",
  "block.minecraft.gold_block": "Златен блок",
  "block.minecraft.gold_ore": "Златна руда",
  "block.minecraft.golden_dandelion": "Златно глухарче",
  "block.minecraft.granite": "Гранит",
  "block.minecraft.granite_slab": "Плоча от гранит",
  "block.minecraft.granite_stairs": "Стъпала от гранит",
  "block.minecraft.granite_wall": "Стена от гранит",
  "block.minecraft.grass": "Трева",
  "block.minecraft.grass_block": "Тревист блок",
  "block.minecraft.gravel": "Чакъл",
  "block.minecraft.gray_banner": "Сиво знаме",
  "block.minecraft.gray_bed": "Сиво легло",
  "block.minecraft.gray_candle": "Сива свещ",
  "block.minecraft.gray_candle_cake": "Торта със сива свещ",
  "block.minecraft.gray_carpet": "Сив килим",
  "block.minecraft.gray_concrete": "Сив бетон",
  "block.minecraft.gray_concrete_powder": "Сив цимент",
  "block.minecraft.gray_glazed_terracotta": "Сива глазирана теракота",
  "block.minecraft.gray_shulker_box": "Сива шулкърова кутия",
  "block.minecraft.gray_stained_glass": "Сиво стъкло",
  "block.minecraft.gray_stained_glass_pane": "Сив стъклен панел",
  "block.minecraft.gray_terracotta": "Сива теракота",
  "block.minecraft.gray_wool": "Сива вълна",
  "block.minecraft.green_banner": "Зелено знаме",
  "block.minecraft.green_bed": "Зелено легло",
  "block.minecraft.green_candle": "Зелена свещ",
  "block.minecraft.green_candle_cake": "Торта със зелена свещ",
  "block.minecraft.green_carpet": "Зелен килим",
  "block.minecraft.green_concrete": "Зелен бетон",
  "block.minecraft.green_concrete_powder": "Зелен цимент",
  "block.minecraft.green_glazed_terracotta": "Зелена глазирана теракота",
  "block.minecraft.green_shulker_box": "Зелена шулкърова кутия",
  "block.minecraft.green_stained_glass": "Зелено стъкло",
  "block.minecraft.green_stained_glass_pane": "Зелен стъклен панел",
  "block.minecraft.green_terracotta": "Зелена теракота",
  "block.minecraft.green_wool": "Зелена вълна",
  "block.minecraft.grindstone": "Точило",
  "block.minecraft.hanging_roots": "Висящи корени",
  "block.minecraft.hay_block": "Слама",
  "block.minecraft.heavy_core": "Тежко ядро",
  "block.minecraft.heavy_weighted_pressure_plate": "Тежкочувствителна сигнална плоча",
  "block.minecraft.honey_block": "Меден Блок",
  "block.minecraft.honeycomb_block": "Блок от медени пити",
  "block.minecraft.hopper": "Фуния",
  "block.minecraft.horn_coral": "Рогов корал",
  "block.minecraft.horn_coral_block": "Блок от рогов корал",
  "block.minecraft.horn_coral_fan": "Рогов мек корал",
  "block.minecraft.horn_coral_wall_fan": "Рогов мек корал на стена",
  "block.minecraft.ice": "Лед",
  "block.minecraft.infested_chiseled_stone_bricks": "Изписани каменни тухли с люспеница",
  "block.minecraft.infested_cobblestone": "Калдъръмени камъни с люспеница",
  "block.minecraft.infested_cracked_stone_bricks": "Напукани каменни тухли с люспеница",
  "block.minecraft.infested_deepslate": "Шисти с люспеница",
  "block.minecraft.infested_mossy_stone_bricks": "Мъхести калдъръмени камъни с люспеница",
  "block.minecraft.infested_stone": "Камък с люспеница",
  "block.minecraft.infested_stone_bricks": "Каменни тухли с люспеница",
  "block.minecraft.iron_bars": "Железни решетки",
  "block.minecraft.iron_block": "Железен блок",
  "block.minecraft.iron_chain": "Железна верига",
  "block.minecraft.iron_door": "Желязна врата",
  "block.minecraft.iron_ore": "Желязна руда",
  "block.minecraft.iron_trapdoor": "Железен люк",
  "block.minecraft.jack_o_lantern": "Тиквен фенер",
  "block.minecraft.jigsaw": "Сглобяващ блок",
  "block.minecraft.jukebox": "Джубокс",
  "block.minecraft.jungle_button": "Джунглов бутон",
  "block.minecraft.jungle_door": "Джунглова врата",
  "block.minecraft.jungle_fence": "Джунглова ограда",
  "block.minecraft.jungle_fence_gate": "Джунглова порта",
  "block.minecraft.jungle_hanging_sign": "Джунглова висяща табела",
  "block.minecraft.jungle_leaves": "Джунглови листа",
  "block.minecraft.jungle_log": "Джунглов дънер",
  "block.minecraft.jungle_planks": "Джунглови дъски",
  "block.minecraft.jungle_pressure_plate": "Джунглова претегляща сигнална плоча",
  "block.minecraft.jungle_sapling": "Джунглова фиданка",
  "block.minecraft.jungle_shelf": "Джунглов рафт",
  "block.minecraft.jungle_sign": "Джунглова табела",
  "block.minecraft.jungle_slab": "Джунглова плоча",
  "block.minecraft.jungle_stairs": "Джунглови стъпала",
  "block.minecraft.jungle_trapdoor": "Джунглов люк",
  "block.minecraft.jungle_wall_hanging_sign": "Висяща на стена Джунглава табела",
  "block.minecraft.jungle_wall_sign": "Джунглова табела на стена",
  "block.minecraft.jungle_wood": "Джунглова дървесина",
  "block.minecraft.kelp": "Водорасло",
  "block.minecraft.kelp_plant": "Стебло на водорасло",
  "block.minecraft.ladder": "Стълба",
  "block.minecraft.lantern": "Фенер",
  "block.minecraft.lapis_block": "Лазуритен блок",
  "block.minecraft.lapis_ore": "Лазуритна руда",
  "block.minecraft.large_amethyst_bud": "Голям аметистов кристал",
  "block.minecraft.large_fern": "Голям папрат",
  "block.minecraft.lava": "Лава",
  "block.minecraft.lava_cauldron": "Казан с лава",
  "block.minecraft.leaf_litter": "Листни отпадъци",
  "block.minecraft.lectern": "Поставка за книга",
  "block.minecraft.lever": "Ръчка",
  "block.minecraft.light": "Светлина",
  "block.minecraft.light_blue_banner": "Светлосиньо знаме",
  "block.minecraft.light_blue_bed": "Светлосиньо легло",
  "block.minecraft.light_blue_candle": "Светлосиня свещ",
  "block.minecraft.light_blue_candle_cake": "Торта със светлосиня свещ",
  "block.minecraft.light_blue_carpet": "Светлосин килим",
  "block.minecraft.light_blue_concrete": "Светлосин бетон",
  "block.minecraft.light_blue_concrete_powder": "Светлосин цимент",
  "block.minecraft.light_blue_glazed_terracotta": "Светлосиня глазирана теракота",
  "block.minecraft.light_blue_shulker_box": "Светлосиня шулкърова кутия",
  "block.minecraft.light_blue_stained_glass": "Светлосиньо стъкло",
  "block.minecraft.light_blue_stained_glass_pane": "Светлосин стъклен панел",
  "block.minecraft.light_blue_terracotta": "Светлосиня теракота",
  "block.minecraft.light_blue_wool": "Светлосиня вълна",
  "block.minecraft.light_gray_banner": "Светлосиво знаме",
  "block.minecraft.light_gray_bed": "Светлосиво легло",
  "block.minecraft.light_gray_candle": "Светлосива свещ",
  "block.minecraft.light_gray_candle_cake": "Торта със светлосива свещ",
  "block.minecraft.light_gray_carpet": "Светлосив килим",
  "block.minecraft.light_gray_concrete": "Светлосив бетон",
  "block.minecraft.light_gray_concrete_powder": "Светлосив цимент",
  "block.minecraft.light_gray_glazed_terracotta": "Светлосива глазирана теракота",
  "block.minecraft.light_gray_shulker_box": "Светлосива шулкърова кутия",
  "block.minecraft.light_gray_stained_glass": "Светлосиво стъкло",
  "block.minecraft.light_gray_stained_glass_pane": "Светлосив стъклен панел",
  "block.minecraft.light_gray_terracotta": "Светлосива теракота",
  "block.minecraft.light_gray_wool": "Светлосива вълна",
  "block.minecraft.light_weighted_pressure_plate": "Лекочувствителна сигнална плоча",
  "block.minecraft.lightning_rod": "Гръмоотвод",
  "block.minecraft.lilac": "Люляк",
  "block.minecraft.lily_of_the_valley": "Момина сълза",
  "block.minecraft.lily_pad": "Водна лилия",
  "block.minecraft.lime_banner": "Жълто-зелено знаме",
  "block.minecraft.lime_bed": "Жълто-зелено легло",
  "block.minecraft.lime_candle": "Жълто-зелена свещ",
  "block.minecraft.lime_candle_cake": "Торта с жълто-зелена свещ",
  "block.minecraft.lime_carpet": "Жълто-зелен килим",
  "block.minecraft.lime_concrete": "Жълто-зелен бетон",
  "block.minecraft.lime_concrete_powder": "Жълто-зелен цимент",
  "block.minecraft.lime_glazed_terracotta": "Жълто-зелена глазирана теракота",
  "block.minecraft.lime_shulker_box": "Жълто-зелена шулкърова кутия",
  "block.minecraft.lime_stained_glass": "Жълто-зелено стъкло",
  "block.minecraft.lime_stained_glass_pane": "Жълто-зелен стъклен панел",
  "block.minecraft.lime_terracotta": "Жълто-зелена теракота",
  "block.minecraft.lime_wool": "Жълто-зеленa вълна",
  "block.minecraft.lodestone": "Магнитен камък",
  "block.minecraft.loom": "Тъкачен стан",
  "block.minecraft.magenta_banner": "Пурпурно знаме",
  "block.minecraft.magenta_bed": "Пурпурно легло",
  "block.minecraft.magenta_candle": "Пурпурна свещ",
  "block.minecraft.magenta_candle_cake": "Торта с пурпурна свещ",
  "block.minecraft.magenta_carpet": "Пурпурен килим",
  "block.minecraft.magenta_concrete": "Пурпурен бетон",
  "block.minecraft.magenta_concrete_powder": "Пурпурен цимент",
  "block.minecraft.magenta_glazed_terracotta": "Пурпурна глазирана теракота",
  "block.minecraft.magenta_shulker_box": "Пурпурна шулкърова кутия",
  "block.minecraft.magenta_stained_glass": "Пурпурно стъкло",
  "block.minecraft.magenta_stained_glass_pane": "Пурпурен стъклен панел",
  "block.minecraft.magenta_terracotta": "Пурпурна теракота",
  "block.minecraft.magenta_wool": "Пурпурна вълна",
  "block.minecraft.magma_block": "Блок от магма",
  "block.minecraft.mangrove_button": "Мангров бутон",
  "block.minecraft.mangrove_door": "Мангрова врата",
  "block.minecraft.mangrove_fence": "Мангрова ограда",
  "block.minecraft.mangrove_fence_gate": "Мангрова порта",
  "block.minecraft.mangrove_hanging_sign": "Висяща табела от мангрово дърво",
  "block.minecraft.mangrove_leaves": "Мангрови листа",
  "block.minecraft.mangrove_log": "Мангров дънер",
  "block.minecraft.mangrove_planks": "Мангрови дъски",
  "block.minecraft.mangrove_pressure_plate": "Мангрова претегляща сигнална плоча",
  "block.minecraft.mangrove_propagule": "Мангрова фиданка",
  "block.minecraft.mangrove_roots": "Мангрови корени",
  "block.minecraft.mangrove_shelf": "Мангров рафт",
  "block.minecraft.mangrove_sign": "Мангрова табела",
  "block.minecraft.mangrove_slab": "Мангрова плоча",
  "block.minecraft.mangrove_stairs": "Мангрови стъпала",
  "block.minecraft.mangrove_trapdoor": "Мангров люк",
  "block.minecraft.mangrove_wall_hanging_sign": "Висяща на стена Мангрова табела",
  "block.minecraft.mangrove_wall_sign": "Мангрова табела на стена",
  "block.minecraft.mangrove_wood": "Мангрова дървесина",
  "block.minecraft.medium_amethyst_bud": "Среден аметистов кристал",
  "block.minecraft.melon": "Диня",
  "block.minecraft.melon_stem": "Динено стъбло",
  "block.minecraft.moss_block": "Мъхест блок",
  "block.minecraft.moss_carpet": "Килим от мъх",
  "block.minecraft.mossy_cobblestone": "Мъхести калдъръмени камъни",
  "block.minecraft.mossy_cobblestone_slab": "Плоча от мъхести калдъръмени камъни",
  "block.minecraft.mossy_cobblestone_stairs": "Стъпала от мъхести калдъръмени камъни",
  "block.minecraft.mossy_cobblestone_wall": "Мъхеста калдъръмена стена",
  "block.minecraft.mossy_stone_brick_slab": "Плоча от мъхести каменни тухли",
  "block.minecraft.mossy_stone_brick_stairs": "Стъпала от мъхести каменни тухли",
  "block.minecraft.mossy_stone_brick_wall": "Стена от мъхести каменни тухли",
  "block.minecraft.mossy_stone_bricks": "Мъхести каменни тухли",
  "block.minecraft.moving_piston": "Движещо се бутало",
  "block.minecraft.mud": "Кал",
  "block.minecraft.mud_brick_slab": "Плоча от кирпичени тухли",
  "block.minecraft.mud_brick_stairs": "Стъпала от кирпичени тухли",
  "block.minecraft.mud_brick_wall": "Стена от кирпичени тухли",
  "block.minecraft.mud_bricks": "Кирпичени тухли",
  "block.minecraft.muddy_mangrove_roots": "Кални мангрови корени",
  "block.minecraft.mushroom_stem": "Стебло на гъба",
  "block.minecraft.mycelium": "Мицел",
  "block.minecraft.nether_brick_fence": "Тухлена ограда от Недъра",
  "block.minecraft.nether_brick_slab": "Плоча от Недъра",
  "block.minecraft.nether_brick_stairs": "Тухлени стъпала от Недъра",
  "block.minecraft.nether_brick_wall": "Стена от тухли от Недъра",
  "block.minecraft.nether_bricks": "Тухли от Недъра",
  "block.minecraft.nether_gold_ore": "Адска златна руда",
  "block.minecraft.nether_portal": "Портал към Недъра",
  "block.minecraft.nether_quartz_ore": "Кварцова руда от Недъра",
  "block.minecraft.nether_sprouts": "Nether филиз",
  "block.minecraft.nether_wart": "Брадавица от Недъра",
  "block.minecraft.nether_wart_block": "Блок от брадавица от Недъра",
  "block.minecraft.netherite_block": "Недърайт блок",
  "block.minecraft.netherrack": "Камък от Недъра",
  "block.minecraft.note_block": "Музикален блок",
  "block.minecraft.oak_button": "Дъбов бутон",
  "block.minecraft.oak_door": "Дъбова врата",
  "block.minecraft.oak_fence": "Дъбова ограда",
  "block.minecraft.oak_fence_gate": "Дъбова порта",
  "block.minecraft.oak_hanging_sign": "Дъбова висяща табела",
  "block.minecraft.oak_leaves": "Дъбови листа",
  "block.minecraft.oak_log": "Дъбов дънер",
  "block.minecraft.oak_planks": "Дъбови дъски",
  "block.minecraft.oak_pressure_plate": "Дъбова претегляща сигнална плоча",
  "block.minecraft.oak_sapling": "Дъбова фиданка",
  "block.minecraft.oak_shelf": "Дъбов рафт",
  "block.minecraft.oak_sign": "Дъбова табела",
  "block.minecraft.oak_slab": "Дъбова плоча",
  "block.minecraft.oak_stairs": "Дъбови стъпала",
  "block.minecraft.oak_trapdoor": "Дъбов люк",
  "block.minecraft.oak_wall_hanging_sign": "Висяща на стена дъбова табела",
  "block.minecraft.oak_wall_sign": "Дъбова табела на стена",
  "block.minecraft.oak_wood": "Дъбова дървесина",
  "block.minecraft.observer": "Наблюдател",
  "block.minecraft.obsidian": "Обсидиан",
  "block.minecraft.ochre_froglight": "Охра фроглайт",
  "block.minecraft.ominous_banner": "Злавещо знаме",
  "block.minecraft.open_eyeblossom": "Отворен очеболец",
  "block.minecraft.orange_banner": "Оранжево знаме",
  "block.minecraft.orange_bed": "Оранжево легло",
  "block.minecraft.orange_candle": "Оранжева свещ",
  "block.minecraft.orange_candle_cake": "Торта с оранжева свещ",
  "block.minecraft.orange_carpet": "Оранжев килим",
  "block.minecraft.orange_concrete": "Оранжев бетон",
  "block.minecraft.orange_concrete_powder": "Оранжев цимент",
  "block.minecraft.orange_glazed_terracotta": "Оранжева глазирана теракота",
  "block.minecraft.orange_shulker_box": "Оранжева шулкърова кутия",
  "block.minecraft.orange_stained_glass": "Оранжево стъкло",
  "block.minecraft.orange_stained_glass_pane": "Оранжев стъклен панел",
  "block.minecraft.orange_terracotta": "Оранжева теракота",
  "block.minecraft.orange_tulip": "Оранжево лале",
  "block.minecraft.orange_wool": "Оранжева вълна",
  "block.minecraft.oxeye_daisy": "Бяла маргаритка",
  "block.minecraft.oxidized_chiseled_copper": "Окислена издялана мед",
  "block.minecraft.oxidized_copper": "Окислена мед",
  "block.minecraft.oxidized_copper_bars": "Окислени медни решетки",
  "block.minecraft.oxidized_copper_bulb": "Окислена медна крушка",
  "block.minecraft.oxidized_copper_chain": "Окислена медна верига",
  "block.minecraft.oxidized_copper_chest": "Окислен меден сандък",
  "block.minecraft.oxidized_copper_door": "Окислена медна врата",
  "block.minecraft.oxidized_copper_golem_statue": "Окислена статуя на меден голем",
  "block.minecraft.oxidized_copper_grate": "Окислена медна решетка",
  "block.minecraft.oxidized_copper_lantern": "Окислен меден фенер",
  "block.minecraft.oxidized_copper_trapdoor": "Окислен меден люк",
  "block.minecraft.oxidized_cut_copper": "Окислена сечена мед",
  "block.minecraft.oxidized_cut_copper_slab": "Окислена плоча от сечена мед",
  "block.minecraft.oxidized_cut_copper_stairs": "Окислени стъпала от сечена мед",
  "block.minecraft.oxidized_lightning_rod": "Окислен мълниеотвод",
  "block.minecraft.packed_ice": "Втвърден лед",
  "block.minecraft.packed_mud": "Кирпич",
  "block.minecraft.pale_hanging_moss": "Блед висящ мъх",
  "block.minecraft.pale_moss_block": "Блед мъхест блок",
  "block.minecraft.pale_moss_carpet": "Килим от блед мъх",
  "block.minecraft.pale_oak_button": "Бутон от блед дъб",
  "block.minecraft.pale_oak_door": "Врата от блед дъб",
  "block.minecraft.pale_oak_fence": "Ограда от блед дъб",
  "block.minecraft.pale_oak_fence_gate": "Порта от блед дъб",
  "block.minecraft.pale_oak_hanging_sign": "Висяща табела от блед дъб",
  "block.minecraft.pale_oak_leaves": "Листа от блед дъб",
  "block.minecraft.pale_oak_log": "Дънер от блед дъб",
  "block.minecraft.pale_oak_planks": "Дъски от блед дъб",
  "block.minecraft.pale_oak_pressure_plate": "Претегляща сигнална плоча от блед дъб",
  "block.minecraft.pale_oak_sapling": "Фиданка на блед дъб",
  "block.minecraft.pale_oak_shelf": "Бледодъбов рафт",
  "block.minecraft.pale_oak_sign": "Табела от блед дъб",
  "block.minecraft.pale_oak_slab": "Плоча от блед дъб",
  "block.minecraft.pale_oak_stairs": "Стъпала от блед дъб",
  "block.minecraft.pale_oak_trapdoor": "Люк от блед дъб",
  "block.minecraft.pale_oak_wall_hanging_sign": "Висяща на стена табела от блед дъб",
  "block.minecraft.pale_oak_wall_sign": "Табела от блед дъб на стена",
  "block.minecraft.pale_oak_wood": "Дървесина от блед дъб",
  "block.minecraft.pearlescent_froglight": "Перлен фроглайт",
  "block.minecraft.peony": "Божур",
  "block.minecraft.petrified_oak_slab": "Вкаменена дъбова плоча",
  "block.minecraft.piglin_head": "Глава на Piglin",
  "block.minecraft.piglin_wall_head": "Глава на Пиглин на стена",
  "block.minecraft.pink_banner": "Розово знаме",
  "block.minecraft.pink_bed": "Розово легло",
  "block.minecraft.pink_candle": "Розова свещ",
  "block.minecraft.pink_candle_cake": "Торта с розова свещ",
  "block.minecraft.pink_carpet": "Розов килим",
  "block.minecraft.pink_concrete": "Розов бетон",
  "block.minecraft.pink_concrete_powder": "Розов цимент",
  "block.minecraft.pink_glazed_terracotta": "Розова глазирана теракота",
  "block.minecraft.pink_petals": "Розови листеца",
  "block.minecraft.pink_shulker_box": "Розова шулкърова кутия",
  "block.minecraft.pink_stained_glass": "Розово стъкло",
  "block.minecraft.pink_stained_glass_pane": "Розов стъклен панел",
  "block.minecraft.pink_terracotta": "Розова теракота",
  "block.minecraft.pink_tulip": "Розово лале",
  "block.minecraft.pink_wool": "Розова вълна",
  "block.minecraft.piston": "Бутало",
  "block.minecraft.piston_head": "Глава на бутало",
  "block.minecraft.pitcher_crop": "Cтомна култура",
  "block.minecraft.pitcher_plant": "Стомнично цвете",
  "block.minecraft.player_head": "Глава на играч",
  "block.minecraft.player_head.named": "Главата на %s",
  "block.minecraft.player_wall_head": "Глава на играч на стена",
  "block.minecraft.podzol": "Неплодородна почва",
  "block.minecraft.pointed_dripstone": "Синтрово образувание",
  "block.minecraft.polished_andesite": "Полиран андезит",
  "block.minecraft.polished_andesite_slab": "Плоча от полиран андезит",
  "block.minecraft.polished_andesite_stairs": "Стъпала от полиран андезит",
  "block.minecraft.polished_basalt": "Полиран базалт",
  "block.minecraft.polished_blackstone": "Полиран черен камък",
  "block.minecraft.polished_blackstone_brick_slab": "Полирана плоча от чернокамъчни тухли",
  "block.minecraft.polished_blackstone_brick_stairs": "Полирани чернокаменни тухлени стъпала",
  "block.minecraft.polished_blackstone_brick_wall": "Полирана тухлена стена от черен камък",
  "block.minecraft.polished_blackstone_bricks": "Полирани тухли от черен камък",
  "block.minecraft.polished_blackstone_button": "Бутон от полиран черен камък",
  "block.minecraft.polished_blackstone_pressure_plate": "Сигнална плоча от полиран черен камък",
  "block.minecraft.polished_blackstone_slab": "Полирана плоча от черен камък",
  "block.minecraft.polished_blackstone_stairs": "Полирани стъпала от черен камък",
  "block.minecraft.polished_blackstone_wall": "Полирана стена от черен камък",
  "block.minecraft.polished_deepslate": "Полирани шисти",
  "block.minecraft.polished_deepslate_slab": "Полирана шистова плоча",
  "block.minecraft.polished_deepslate_stairs": "Полирани шистови стъпала",
  "block.minecraft.polished_deepslate_wall": "Полирана шистова стена",
  "block.minecraft.polished_diorite": "Полиран диорит",
  "block.minecraft.polished_diorite_slab": "Плоча от полиран диорит",
  "block.minecraft.polished_diorite_stairs": "Стъпала от полиран диорит",
  "block.minecraft.polished_granite": "Полиран гранит",
  "block.minecraft.polished_granite_slab": "Плоча от полиран гранит",
  "block.minecraft.polished_granite_stairs": "Стъпала от полиран гранит",
  "block.minecraft.polished_tuff": "Полиран туф",
  "block.minecraft.polished_tuff_slab": "Полирана плоча от туф",
  "block.minecraft.polished_tuff_stairs": "Полирани стъпала от туф",
  "block.minecraft.polished_tuff_wall": "Полирана стена от туф",
  "block.minecraft.poppy": "Мак",
  "block.minecraft.potatoes": "Картофи",
  "block.minecraft.potted_acacia_sapling": "Саксия с акациева фиданка",
  "block.minecraft.potted_allium": "Саксия с лук",
  "block.minecraft.potted_azalea_bush": "Саксия с азалия",
  "block.minecraft.potted_azure_bluet": "Саксия с лазурна метличина",
  "block.minecraft.potted_bamboo": "Саксия с бамбук",
  "block.minecraft.potted_birch_sapling": "Саксия с брезова фиданка",
  "block.minecraft.potted_blue_orchid": "Саксия със синя орхидея",
  "block.minecraft.potted_brown_mushroom": "Саксия с кафява гъба",
  "block.minecraft.potted_cactus": "Саксия с кактус",
  "block.minecraft.potted_cherry_sapling": "Саксия с черешова фиданка",
  "block.minecraft.potted_closed_eyeblossom": "Саксия със затворен очеболец",
  "block.minecraft.potted_cornflower": "Саксия със синя метличина",
  "block.minecraft.potted_crimson_fungus": "Пурпурнa гъбa в саксия",
  "block.minecraft.potted_crimson_roots": "Пурпурни корени в саксия",
  "block.minecraft.potted_dandelion": "Саксия с глухарче",
  "block.minecraft.potted_dark_oak_sapling": "Саксия с фиданка на черен дъб",
  "block.minecraft.potted_dead_bush": "Саксия с изсъхнал храст",
  "block.minecraft.potted_fern": "Саксия с папрат",
  "block.minecraft.potted_flowering_azalea_bush": "Саксия с цъфтяща азалия",
  "block.minecraft.potted_golden_dandelion": "Саксия със златно глухарче",
  "block.minecraft.potted_jungle_sapling": "Саксия с джунглова фиданка",
  "block.minecraft.potted_lily_of_the_valley": "Саксия с момина сълза",
  "block.minecraft.potted_mangrove_propagule": "Мангровата фиданка в саксия",
  "block.minecraft.potted_oak_sapling": "Саксия с дъбова фиданка",
  "block.minecraft.potted_open_eyeblossom": "Саксия с отворен очеболец",
  "block.minecraft.potted_orange_tulip": "Саксия с оранжево лале",
  "block.minecraft.potted_oxeye_daisy": "Саксия с маргаритка",
  "block.minecraft.potted_pale_oak_sapling": "Саксия с фиданка от блед дъб",
  "block.minecraft.potted_pink_tulip": "Саксия с розово лале",
  "block.minecraft.potted_poppy": "Саксия с мак",
  "block.minecraft.potted_red_mushroom": "Саксия с червена гъба",
  "block.minecraft.potted_red_tulip": "Саксия с червено лале",
  "block.minecraft.potted_spruce_sapling": "Саксия със смърчова фиданка",
  "block.minecraft.potted_torchflower": "Саксия с факлено цвете",
  "block.minecraft.potted_warped_fungus": "Шантава гъба в саксия",
  "block.minecraft.potted_warped_roots": "Шантави корени в саксия",
  "block.minecraft.potted_white_tulip": "Саксия с бяло лале",
  "block.minecraft.potted_wither_rose": "Саксия с уидър роза",
  "block.minecraft.powder_snow": "Пухкав сняг",
  "block.minecraft.powder_snow_cauldron": "Казан с пухкав сняг",
  "block.minecraft.powered_rail": "Захранвани релси",
  "block.minecraft.prismarine": "Призмарин",
  "block.minecraft.prismarine_brick_slab": "Плоча от призмаринови тухли",
  "block.minecraft.prismarine_brick_stairs": "Стъпала от призмаринови тухли",
  "block.minecraft.prismarine_bricks": "Призмаринови тухли",
  "block.minecraft.prismarine_slab": "Призмаринова плоча",
  "block.minecraft.prismarine_stairs": "Призмаринови стъпала",
  "block.minecraft.prismarine_wall": "Призмаринова стена",
  "block.minecraft.pumpkin": "Тиква",
  "block.minecraft.pumpkin_stem": "Стебло",
  "block.minecraft.purple_banner": "Лилаво знаме",
  "block.minecraft.purple_bed": "Лилаво легло",
  "block.minecraft.purple_candle": "Лилава свещ",
  "block.minecraft.purple_candle_cake": "Торта с лилава свещ",
  "block.minecraft.purple_carpet": "Лилав килим",
  "block.minecraft.purple_concrete": "Лилав бетон",
  "block.minecraft.purple_concrete_powder": "Лилав цимент",
  "block.minecraft.purple_glazed_terracotta": "Лилава глазирана теракота",
  "block.minecraft.purple_shulker_box": "Лилава шулкърова кутия",
  "block.minecraft.purple_stained_glass": "Лилаво стъкло",
  "block.minecraft.purple_stained_glass_pane": "Лилав стъклен панел",
  "block.minecraft.purple_terracotta": "Лилава теракота",
  "block.minecraft.purple_wool": "Лилава вълна",
  "block.minecraft.purpur_block": "Пурпурен блок",
  "block.minecraft.purpur_pillar": "Пурпурна колона",
  "block.minecraft.purpur_slab": "Пурпурна плоча",
  "block.minecraft.purpur_stairs": "Пурпурни стълби",
  "block.minecraft.quartz_block": "Кварцов блок",
  "block.minecraft.quartz_bricks": "Кварцови тухли",
  "block.minecraft.quartz_pillar": "Кварцова колона",
  "block.minecraft.quartz_slab": "Кварцова плоча",
  "block.minecraft.quartz_stairs": "Кварцови стъпала",
  "block.minecraft.rail": "Релса",
  "block.minecraft.raw_copper_block": "Блок от необработена мед",
  "block.minecraft.raw_gold_block": "Блок от необработено злато",
  "block.minecraft.raw_iron_block": "Блок от необработено желязо",
  "block.minecraft.red_banner": "Червено знаме",
  "block.minecraft.red_bed": "Червено легло",
  "block.minecraft.red_candle": "Червена свещ",
  "block.minecraft.red_candle_cake": "Торта с червена свещ",
  "block.minecraft.red_carpet": "Червен килим",
  "block.minecraft.red_concrete": "Червен бетон",
  "block.minecraft.red_concrete_powder": "Червен цимент",
  "block.minecraft.red_glazed_terracotta": "Червена глазирана теракота",
  "block.minecraft.red_mushroom": "Червена гъба",
  "block.minecraft.red_mushroom_block": "Червен гъбен блок",
  "block.minecraft.red_nether_brick_slab": "Плоча от червени тухли от Недъра",
  "block.minecraft.red_nether_brick_stairs": "Стъпала от червени тухли от Недъра",
  "block.minecraft.red_nether_brick_wall": "Стена от червени тухли от Недъра",
  "block.minecraft.red_nether_bricks": "Червени тухли от Недъра",
  "block.minecraft.red_sand": "Червен пясък",
  "block.minecraft.red_sandstone": "Червен пясъчник",
  "block.minecraft.red_sandstone_slab": "Плоча от червен пясъчник",
  "block.minecraft.red_sandstone_stairs": "Стъпала от червен пясъчник",
  "block.minecraft.red_sandstone_wall": "Стена от червен пясъчник",
  "block.minecraft.red_shulker_box": "Червена шулкърова кутия",
  "block.minecraft.red_stained_glass": "Червено стъкло",
  "block.minecraft.red_stained_glass_pane": "Червен стъклен панел",
  "block.minecraft.red_terracotta": "Червена теракота",
  "block.minecraft.red_tulip": "Червено лале",
  "block.minecraft.red_wool": "Червена вълна",
  "block.minecraft.redstone_block": "Червенокаменен блок",
  "block.minecraft.redstone_lamp": "Червенокаменна лампа",
  "block.minecraft.redstone_ore": "Червенокаменна руда",
  "block.minecraft.redstone_torch": "Червенокаменна факла",
  "block.minecraft.redstone_wall_torch": "Факла от червен камък",
  "block.minecraft.redstone_wire": "Червенокаменна жица",
  "block.minecraft.reinforced_deepslate": "Подсилени шисти",
  "block.minecraft.repeater": "Червенокаменен повторител",
  "block.minecraft.repeating_command_block": "Повтарящ команден блок",
  "block.minecraft.resin_block": "Блок от смола",
  "block.minecraft.resin_brick_slab": "Плоча от тухли от смола",
  "block.minecraft.resin_brick_stairs": "Стъпала от тухли от смола",
  "block.minecraft.resin_brick_wall": "Стена от тухли от смола",
  "block.minecraft.resin_bricks": "Тухли от смола",
  "block.minecraft.resin_clump": "Къс смола",
  "block.minecraft.respawn_anchor": "Прераждаща котва",
  "block.minecraft.rooted_dirt": "Корениста пръст",
  "block.minecraft.rose_bush": "Розов храст",
  "block.minecraft.sand": "Пясък",
  "block.minecraft.sandstone": "Пясъчник",
  "block.minecraft.sandstone_slab": "Плоча от пясъчник",
  "block.minecraft.sandstone_stairs": "Стъпала от пясъчник",
  "block.minecraft.sandstone_wall": "Стена от пясъчник",
  "block.minecraft.scaffolding": "Скеле",
  "block.minecraft.sculk": "Скълк",
  "block.minecraft.sculk_catalyst": "Скълк стимулатор",
  "block.minecraft.sculk_sensor": "Скълк сензор",
  "block.minecraft.sculk_shrieker": "Скълк ларинкс",
  "block.minecraft.sculk_vein": "Скълк жили",
  "block.minecraft.sea_lantern": "Морски фенер",
  "block.minecraft.sea_pickle": "Огнетелка",
  "block.minecraft.seagrass": "Морска трева",
  "block.minecraft.set_spawn": "Точка на прераждане зададена",
  "block.minecraft.short_dry_grass": "\nКъса суха трева",
  "block.minecraft.short_grass": "Ниска трева",
  "block.minecraft.shroomlight": "Гъбена лампа",
  "block.minecraft.shulker_box": "Шулкърова кутия",
  "block.minecraft.skeleton_skull": "Череп на скелет",
  "block.minecraft.skeleton_wall_skull": "Череп на скелет на стена",
  "block.minecraft.slime_block": "Блок от слуз",
  "block.minecraft.small_amethyst_bud": "Малък аметистов кристал",
  "block.minecraft.small_dripleaf": "Малък паделист",
  "block.minecraft.smithing_table": "Коваческа маса",
  "block.minecraft.smoker": "Пушечна фурна",
  "block.minecraft.smooth_basalt": "Гладък базалт",
  "block.minecraft.smooth_quartz": "Блок от гладък кварц",
  "block.minecraft.smooth_quartz_slab": "Плоча от гладък кварц",
  "block.minecraft.smooth_quartz_stairs": "Стъпала от гладък кварц",
  "block.minecraft.smooth_red_sandstone": "Гладък червен пясъчник",
  "block.minecraft.smooth_red_sandstone_slab": "Плоча от гладък червен пясъчник",
  "block.minecraft.smooth_red_sandstone_stairs": "Стъпала от гладък червен пясъчник",
  "block.minecraft.smooth_sandstone": "Гладък пясъчник",
  "block.minecraft.smooth_sandstone_slab": "Плоча от гладък пясъчник",
  "block.minecraft.smooth_sandstone_stairs": "Стъпала от гладък пясъчник",
  "block.minecraft.smooth_stone": "Гладък камък",
  "block.minecraft.smooth_stone_slab": "Гладка каменна плоча",
  "block.minecraft.sniffer_egg": "Яйце на Снифър",
  "block.minecraft.snow": "Сняг",
  "block.minecraft.snow_block": "Снежен блок",
  "block.minecraft.soul_campfire": "Душевен огън",
  "block.minecraft.soul_fire": "Огън на душите",
  "block.minecraft.soul_lantern": "Душевен фенер",
  "block.minecraft.soul_sand": "Пясък на душите",
  "block.minecraft.soul_soil": "Земя на душите",
  "block.minecraft.soul_torch": "Обладана факла",
  "block.minecraft.soul_wall_torch": "Стенна обладана факла",
  "block.minecraft.spawn.not_valid": "Нямате легло или заредена прераждаща котва, или е нямало място за прераждане",
  "block.minecraft.spawner": "Размножител на чудовища",
  "block.minecraft.spawner.desc1": "Взаимодейства с призоваващо яйце:",
  "block.minecraft.spawner.desc2": "Задава тип на моб",
  "block.minecraft.sponge": "Гъба",
  "block.minecraft.spore_blossom": "Цъфтяща спора",
  "block.minecraft.spruce_button": "Смърчов бутон",
  "block.minecraft.spruce_door": "Смърчова врата",
  "block.minecraft.spruce_fence": "Смърчова ограда",
  "block.minecraft.spruce_fence_gate": "Смърчова порта",
  "block.minecraft.spruce_hanging_sign": "Смърчова висяща табела",
  "block.minecraft.spruce_leaves": "Смърчови листа",
  "block.minecraft.spruce_log": "Смърчов дънер",
  "block.minecraft.spruce_planks": "Смърчови дъски",
  "block.minecraft.spruce_pressure_plate": "Смърчова претегляща сигнална плоча",
  "block.minecraft.spruce_sapling": "Смърчова фиданка",
  "block.minecraft.spruce_shelf": "Смърчов рафт",
  "block.minecraft.spruce_sign": "Смърчова табела",
  "block.minecraft.spruce_slab": "Смърчова плоча",
  "block.minecraft.spruce_stairs": "Смърчови стъпала",
  "block.minecraft.spruce_trapdoor": "Смърчов люк",
  "block.minecraft.spruce_wall_hanging_sign": "Висяща на стена Смърчова табела",
  "block.minecraft.spruce_wall_sign": "Смърчова табела на стена",
  "block.minecraft.spruce_wood": "Смърчова дървесина",
  "block.minecraft.sticky_piston": "Лепкаво бутало",
  "block.minecraft.stone": "Камък",
  "block.minecraft.stone_brick_slab": "Плоча от каменни тухли",
  "block.minecraft.stone_brick_stairs": "Каменно-тухлени стъпала",
  "block.minecraft.stone_brick_wall": "Стена от каменни тухли",
  "block.minecraft.stone_bricks": "Каменни тухли",
  "block.minecraft.stone_button": "Каменен бутон",
  "block.minecraft.stone_pressure_plate": "Каменна претегляща сигнална плоча",
  "block.minecraft.stone_slab": "Каменна плоча",
  "block.minecraft.stone_stairs": "Стъпала от камък",
  "block.minecraft.stonecutter": "Каменоделски циркуляр",
  "block.minecraft.stripped_acacia_log": "Оголен акациев дънер",
  "block.minecraft.stripped_acacia_wood": "Оголена акациева дървесина",
  "block.minecraft.stripped_bamboo_block": "Блок от оголен бамбук",
  "block.minecraft.stripped_birch_log": "Оголен брезов дънер",
  "block.minecraft.stripped_birch_wood": "Оголена брезова дървесина",
  "block.minecraft.stripped_cherry_log": "Оголен черешов дънер",
  "block.minecraft.stripped_cherry_wood": "Оголена черешова дървесина",
  "block.minecraft.stripped_crimson_hyphae": "Оголени пурпурни хифи",
  "block.minecraft.stripped_crimson_stem": "Оголено пурпурно стъбло",
  "block.minecraft.stripped_dark_oak_log": "Оголен дънер от черен дъб",
  "block.minecraft.stripped_dark_oak_wood": "Оголена дървесина от черен дъб",
  "block.minecraft.stripped_jungle_log": "Оголен джунглов дънер",
  "block.minecraft.stripped_jungle_wood": "Оголена джунглова дървесина",
  "block.minecraft.stripped_mangrove_log": "Оголен мангров дънер",
  "block.minecraft.stripped_mangrove_wood": "Оголена мангрова дървесина",
  "block.minecraft.stripped_oak_log": "Оголен дъбов дънер",
  "block.minecraft.stripped_oak_wood": "Оголена дъбова дървесина",
  "block.minecraft.stripped_pale_oak_log": "Оголен дънер от блед дъб",
  "block.minecraft.stripped_pale_oak_wood": "Оголена дървесина от блед дъб",
  "block.minecraft.stripped_spruce_log": "Оголен смърчов дънер",
  "block.minecraft.stripped_spruce_wood": "Оголена смърчова дървесина",
  "block.minecraft.stripped_warped_hyphae": "Оголени шантави хифи",
  "block.minecraft.stripped_warped_stem": "Оголено шантаво стъбло",
  "block.minecraft.structure_block": "Конструкционен блок",
  "block.minecraft.structure_void": "Конструкционна празнота",
  "block.minecraft.sugar_cane": "Захарна тръстика",
  "block.minecraft.sunflower": "Слънчоглед",
  "block.minecraft.suspicious_gravel": "Подозрителен чакъл",
  "block.minecraft.suspicious_sand": "Подозрителен пясък",
  "block.minecraft.sweet_berry_bush": "Храст със сладки горски плодове",
  "block.minecraft.tall_dry_grass": "Висока суха трева",
  "block.minecraft.tall_grass": "Висока трева",
  "block.minecraft.tall_seagrass": "Висока морска трева",
  "block.minecraft.target": "Мишена",
  "block.minecraft.terracotta": "Теракота",
  "block.minecraft.test_block": "Тестови блок",
  "block.minecraft.test_instance_block": "Тестова инстанция на блок",
  "block.minecraft.tinted_glass": "Затъмнено стъкло",
  "block.minecraft.tnt": "Динамит",
  "block.minecraft.tnt.disabled": "Експлозиите на TNT са деактивирани",
  "block.minecraft.torch": "Факла",
  "block.minecraft.torchflower": "Факлено цвете",
  "block.minecraft.torchflower_crop": "Реколта от факлени цветя",
  "block.minecraft.trapped_chest": "Сандък с капан",
  "block.minecraft.trial_spawner": "Изпитателен Размножител",
  "block.minecraft.tripwire": "Жица капан",
  "block.minecraft.tripwire_hook": "Кука за капани",
  "block.minecraft.tube_coral": "Тръбообразен корал",
  "block.minecraft.tube_coral_block": "Блок от тръбен корал",
  "block.minecraft.tube_coral_fan": "Тръбен мек корал",
  "block.minecraft.tube_coral_wall_fan": "Тръбен мек корал на стена",
  "block.minecraft.tuff": "Туф",
  "block.minecraft.tuff_brick_slab": "Плоча от тухли от туф",
  "block.minecraft.tuff_brick_stairs": "Тухлени стъпала от туф",
  "block.minecraft.tuff_brick_wall": "Тухлена стена от туф",
  "block.minecraft.tuff_bricks": "Тухли от туф",
  "block.minecraft.tuff_slab": "Плоча от туф",
  "block.minecraft.tuff_stairs": "Стъпала от туф",
  "block.minecraft.tuff_wall": "Стена от туф",
  "block.minecraft.turtle_egg": "Яйце на костенурка",
  "block.minecraft.twisting_vines": "Увити лияни",
  "block.minecraft.twisting_vines_plant": "Усукване лозя растение",
  "block.minecraft.vault": "Трезор",
  "block.minecraft.verdant_froglight": "Зелен фроглайт",
  "block.minecraft.vine": "Лиани",
  "block.minecraft.void_air": "Въздух в празнотата",
  "block.minecraft.wall_torch": "Стенна факла",
  "block.minecraft.warped_button": "Шантав бутон",
  "block.minecraft.warped_door": "Шантава врата",
  "block.minecraft.warped_fence": "Шантава ограда",
  "block.minecraft.warped_fence_gate": "Шантава порта",
  "block.minecraft.warped_fungus": "Шантава гъба",
  "block.minecraft.warped_hanging_sign": "Шантава висяща табела",
  "block.minecraft.warped_hyphae": "Шантави хифи",
  "block.minecraft.warped_nylium": "Шантав найлиум",
  "block.minecraft.warped_planks": "Шантави дъски",
  "block.minecraft.warped_pressure_plate": "Шантава сигнална плоча",
  "block.minecraft.warped_roots": "Шантави корени",
  "block.minecraft.warped_shelf": "Шантав рафт",
  "block.minecraft.warped_sign": "Шантава табела",
  "block.minecraft.warped_slab": "Шантави дъски",
  "block.minecraft.warped_stairs": "Шантави стъпала",
  "block.minecraft.warped_stem": "Шантаво стъбло",
  "block.minecraft.warped_trapdoor": "Шантав люк",
  "block.minecraft.warped_wall_hanging_sign": "Висяща на стена Шантава табела",
  "block.minecraft.warped_wall_sign": "Шантава стенна табела",
  "block.minecraft.warped_wart_block": "Шантав блок от брадавици",
  "block.minecraft.water": "Вода",
  "block.minecraft.water_cauldron": "Казан с вода",
  "block.minecraft.waxed_chiseled_copper": "Ваксирана издялана мед",
  "block.minecraft.waxed_copper_bars": "Запечатани медни решетки",
  "block.minecraft.waxed_copper_block": "Запечатан блок от мед",
  "block.minecraft.waxed_copper_bulb": "Ваксирана медна крушка",
  "block.minecraft.waxed_copper_chain": "Запечатана медна верига",
  "block.minecraft.waxed_copper_chest": "Ваксиран меден сандък",
  "block.minecraft.waxed_copper_door": "Ваксирана медна врата",
  "block.minecraft.waxed_copper_golem_statue": "Ваксирана статуя на меден голем",
  "block.minecraft.waxed_copper_grate": "Ваксирана медна решетка",
  "block.minecraft.waxed_copper_lantern": "Запечатан меден фенер",
  "block.minecraft.waxed_copper_trapdoor": "Ваксиран меден люк",
  "block.minecraft.waxed_cut_copper": "Запечатана сечена мед",
  "block.minecraft.waxed_cut_copper_slab": "Запечатана плоча от сечена мед",
  "block.minecraft.waxed_cut_copper_stairs": "Запечатани стъпала от сечена мед",
  "block.minecraft.waxed_exposed_chiseled_copper": "Ваксирана изложена издялана мед",
  "block.minecraft.waxed_exposed_copper": "Ваксирана изложена мед",
  "block.minecraft.waxed_exposed_copper_bars": "Запечатани оголени медни решетки",
  "block.minecraft.waxed_exposed_copper_bulb": "Ваксирана изложена медна крушка",
  "block.minecraft.waxed_exposed_copper_chain": "Запечатана оголена медна верига",
  "block.minecraft.waxed_exposed_copper_chest": "Ваксиран изложен меден сандък",
  "block.minecraft.waxed_exposed_copper_door": "Ваксирана изложена медна врата",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Ваксирана изложена статуя на меден голем",
  "block.minecraft.waxed_exposed_copper_grate": "Ваксирана изложена медна решетка",
  "block.minecraft.waxed_exposed_copper_lantern": "Запечатан оголен меден фенер",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Ваксиран изложен меден люк",
  "block.minecraft.waxed_exposed_cut_copper": "Ваксирана изложена сечена мед",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Ваксирана изложена плоча от сечена мед",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Ваксирани изложени стъпала от сечена мед",
  "block.minecraft.waxed_exposed_lightning_rod": "Запечатан незащитен мълниеотвод",
  "block.minecraft.waxed_lightning_rod": "Незащитен мълниеотвод",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Ваксирана окислена издялана мед",
  "block.minecraft.waxed_oxidized_copper": "Запечатана окислена мед",
  "block.minecraft.waxed_oxidized_copper_bars": "Запечатани окислени медни решетки",
  "block.minecraft.waxed_oxidized_copper_bulb": "Ваксирана окислена медна крушка",
  "block.minecraft.waxed_oxidized_copper_chain": "Запечатана окислена медна верига",
  "block.minecraft.waxed_oxidized_copper_chest": "Ваксиран окислен меден сандък",
  "block.minecraft.waxed_oxidized_copper_door": "Ваксирана окислена медна врата",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Ваксирана окислена статуя на меден голем",
  "block.minecraft.waxed_oxidized_copper_grate": "Ваксирана окислена медна решетка",
  "block.minecraft.waxed_oxidized_copper_lantern": "Запечатан окислен меден фенер",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Ваксиран окислен меден люк",
  "block.minecraft.waxed_oxidized_cut_copper": "Запечатана окислена сечена мед",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Запечатана окислена плоча от сечена мед",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Запечатани окислени стъпала от сечена мед",
  "block.minecraft.waxed_oxidized_lightning_rod": "Запечатан окислен мълниеотвод",
  "block.minecraft.waxed_weathered_chiseled_copper": "Ваксирана изветряла издялана мед",
  "block.minecraft.waxed_weathered_copper": "Запечатана ръждясала мед",
  "block.minecraft.waxed_weathered_copper_bars": "Запечатани ръждясали медни решетки",
  "block.minecraft.waxed_weathered_copper_bulb": "Ваксирана изветряла медна крушка",
  "block.minecraft.waxed_weathered_copper_chain": "Запечатана ръждясала медна верига",
  "block.minecraft.waxed_weathered_copper_chest": "Ваксиран изветрял меден сандък",
  "block.minecraft.waxed_weathered_copper_door": "Ваксирана изветряла медна врата",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Ваксирана изветряла статуя на меден голем",
  "block.minecraft.waxed_weathered_copper_grate": "Ваксирана изветряла медна решетка",
  "block.minecraft.waxed_weathered_copper_lantern": "Запечатан ръждясал меден фенер",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Ваксиран изветрял меден люк",
  "block.minecraft.waxed_weathered_cut_copper": "Запечатана ръждясала сечена мед",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Запечатана ръждясала плоча от сечена мед",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Запечатани ръждясали стъпала от сечена мед",
  "block.minecraft.waxed_weathered_lightning_rod": "Запечатана ръждясал мълниеотвод",
  "block.minecraft.weathered_chiseled_copper": "Изветряла издялана мед",
  "block.minecraft.weathered_copper": "Ръждясала мед",
  "block.minecraft.weathered_copper_bars": "Ръждясали медни решетки",
  "block.minecraft.weathered_copper_bulb": "Изветряла медна крушка",
  "block.minecraft.weathered_copper_chain": "Ръждясала медна верига",
  "block.minecraft.weathered_copper_chest": "Изветрял меден сандък",
  "block.minecraft.weathered_copper_door": "Изветряла медна врата",
  "block.minecraft.weathered_copper_golem_statue": "Изветряла статуя на меден голем",
  "block.minecraft.weathered_copper_grate": "Изветряла медна решетка",
  "block.minecraft.weathered_copper_lantern": "Ръждясал меден фенер",
  "block.minecraft.weathered_copper_trapdoor": "Изветрял меден люк",
  "block.minecraft.weathered_cut_copper": "Ръждясала сечена мед",
  "block.minecraft.weathered_cut_copper_slab": "Ръждясала плоча от сечена мед",
  "block.minecraft.weathered_cut_copper_stairs": "Ръждясали стъпала от сечена мед",
  "block.minecraft.weathered_lightning_rod": "Ръждясал мълниеотвод",
  "block.minecraft.weeping_vines": "Плачещи лиани",
  "block.minecraft.weeping_vines_plant": "Плачещa лозя растение",
  "block.minecraft.wet_sponge": "Мокра гъба",
  "block.minecraft.wheat": "Пшеница",
  "block.minecraft.white_banner": "Бяло знаме",
  "block.minecraft.white_bed": "Бяло легло",
  "block.minecraft.white_candle": "Бяла свещ",
  "block.minecraft.white_candle_cake": "Торта с бяла свещ",
  "block.minecraft.white_carpet": "Бял килим",
  "block.minecraft.white_concrete": "Бял бетон",
  "block.minecraft.white_concrete_powder": "Бял цимент",
  "block.minecraft.white_glazed_terracotta": "Бяла глазирана теракота",
  "block.minecraft.white_shulker_box": "Бяла шулкърова кутия",
  "block.minecraft.white_stained_glass": "Бяло стъкло",
  "block.minecraft.white_stained_glass_pane": "Бял стъклен панел",
  "block.minecraft.white_terracotta": "Бяла теракота",
  "block.minecraft.white_tulip": "Бяло лале",
  "block.minecraft.white_wool": "Бяла вълна",
  "block.minecraft.wildflowers": "Диви цветя",
  "block.minecraft.wither_rose": "Уидър роза",
  "block.minecraft.wither_skeleton_skull": "Череп на уидър-скелет",
  "block.minecraft.wither_skeleton_wall_skull": "Череп на уидър-скелет на стена",
  "block.minecraft.yellow_banner": "Жълто знаме",
  "block.minecraft.yellow_bed": "Жълто легло",
  "block.minecraft.yellow_candle": "Жълта свещ",
  "block.minecraft.yellow_candle_cake": "Торта с жълта свещ",
  "block.minecraft.yellow_carpet": "Жълт килим",
  "block.minecraft.yellow_concrete": "Жълт бетон",
  "block.minecraft.yellow_concrete_powder": "Жълт цимент",
  "block.minecraft.yellow_glazed_terracotta": "Жълта глазирана теракота",
  "block.minecraft.yellow_shulker_box": "Жълта шулкърова кутия",
  "block.minecraft.yellow_stained_glass": "Жълто стъкло",
  "block.minecraft.yellow_stained_glass_pane": "Жълт стъклен панел",
  "block.minecraft.yellow_terracotta": "Жълта теракота",
  "block.minecraft.yellow_wool": "Жълта вълна",
  "block.minecraft.zombie_head": "Глава на зомби",
  "block.minecraft.zombie_wall_head": "Глава на зомби на стена",
  "item.minecraft.acacia_boat": "Акациева лодка",
  "item.minecraft.acacia_chest_boat": "Акациева лодка със сандък",
  "item.minecraft.allay_spawn_egg": "Яйце на алей",
  "item.minecraft.amethyst_shard": "Късче аметист",
  "item.minecraft.angler_pottery_shard": "Парче керамика - рибар",
  "item.minecraft.angler_pottery_sherd": "Парче керамика „Рибар“",
  "item.minecraft.apple": "Ябълка",
  "item.minecraft.archer_pottery_shard": "Парче керамика - стрелец",
  "item.minecraft.archer_pottery_sherd": "Парче керамика „Стрелец“",
  "item.minecraft.armadillo_scute": "Черупка от броненосец",
  "item.minecraft.armadillo_spawn_egg": "Яйце на броненосец",
  "item.minecraft.armor_stand": "Стойка за броня",
  "item.minecraft.arms_up_pottery_shard": "Парче керамика „Вдигнати ръце“",
  "item.minecraft.arms_up_pottery_sherd": "Парче керамика „Вдигнати ръце“",
  "item.minecraft.arrow": "Стрела",
  "item.minecraft.axolotl_bucket": "Кофа с аксолотъл",
  "item.minecraft.axolotl_spawn_egg": "Яйце на аксолотъл",
  "item.minecraft.baked_potato": "Печен картоф",
  "item.minecraft.bamboo_chest_raft": "Бамбуков сал със сандък",
  "item.minecraft.bamboo_raft": "Бамбуков сал",
  "item.minecraft.bat_spawn_egg": "Яйце на прилеп",
  "item.minecraft.bee_spawn_egg": "Яйце на пчела",
  "item.minecraft.beef": "Сурово говеждо месо",
  "item.minecraft.beetroot": "Червено цвекло",
  "item.minecraft.beetroot_seeds": "Семена за червено цвекло",
  "item.minecraft.beetroot_soup": "Супа от червено цвекло",
  "item.minecraft.birch_boat": "Брезова лодка",
  "item.minecraft.birch_chest_boat": "Брезова лодка със сандък",
  "item.minecraft.black_bundle": "Черен вързоп",
  "item.minecraft.black_dye": "Черна боя",
  "item.minecraft.black_harness": "Черна сбруя",
  "item.minecraft.blade_pottery_shard": "Парче керамика „Острие“",
  "item.minecraft.blade_pottery_sherd": "Парче керамика „Острие“",
  "item.minecraft.blaze_powder": "Пламенен прах",
  "item.minecraft.blaze_rod": "Пламенна пръчка",
  "item.minecraft.blaze_spawn_egg": "Яйце на пламък",
  "item.minecraft.blue_bundle": "Син вързоп",
  "item.minecraft.blue_dye": "Синя боя",
  "item.minecraft.blue_egg": "Синьо яйце",
  "item.minecraft.blue_harness": "Синя сбруя",
  "item.minecraft.bogged_spawn_egg": "Яйце на затънал",
  "item.minecraft.bolt_armor_trim_smithing_template": "Ковачески шаблон",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Орнамент за броня - Мълния",
  "item.minecraft.bone": "Кокал",
  "item.minecraft.bone_meal": "Стрити кости",
  "item.minecraft.book": "Книга",
  "item.minecraft.bordure_indented_banner_pattern": "Шаблон за знаме - вдлъбнат бордюр",
  "item.minecraft.bow": "Лък",
  "item.minecraft.bowl": "Купа",
  "item.minecraft.bread": "Хляб",
  "item.minecraft.breeze_rod": "Въздушна пръчка",
  "item.minecraft.breeze_spawn_egg": "Яйце на бриз",
  "item.minecraft.brewer_pottery_shard": "Парче керамика „Алхимик“",
  "item.minecraft.brewer_pottery_sherd": "Парче керамика „Алхимик“",
  "item.minecraft.brewing_stand": "Статив за отвари",
  "item.minecraft.brick": "Тухла",
  "item.minecraft.brown_bundle": "Кафяв вързоп",
  "item.minecraft.brown_dye": "Кафява боя",
  "item.minecraft.brown_egg": "Кафяво яйце",
  "item.minecraft.brown_harness": "Кафява сбруя",
  "item.minecraft.brush": "Четка",
  "item.minecraft.bucket": "Кофа",
  "item.minecraft.bundle": "Вързоп",
  "item.minecraft.bundle.empty": "Празен",
  "item.minecraft.bundle.empty.description": "Може да съдържа смесен куп от предмети",
  "item.minecraft.bundle.full": "Пълен",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Парче керамика „Пламък“",
  "item.minecraft.burn_pottery_sherd": "Парче керамика „Пламък“",
  "item.minecraft.camel_husk_spawn_egg": "Яйце на изсъхнала камила",
  "item.minecraft.camel_spawn_egg": "Яйце на камила",
  "item.minecraft.carrot": "Морков",
  "item.minecraft.carrot_on_a_stick": "Морков на клечка",
  "item.minecraft.cat_spawn_egg": "Яйце на котка",
  "item.minecraft.cauldron": "Казан",
  "item.minecraft.cave_spider_spawn_egg": "Яйце на пещерен паяк",
  "item.minecraft.chainmail_boots": "Ботуши на ризница",
  "item.minecraft.chainmail_chestplate": "Ризница",
  "item.minecraft.chainmail_helmet": "Шлем на ризница",
  "item.minecraft.chainmail_leggings": "Панталони на ризница",
  "item.minecraft.charcoal": "Дървени въглища",
  "item.minecraft.cherry_boat": "Черешова лодка",
  "item.minecraft.cherry_chest_boat": "Черешова лодка със сандък",
  "item.minecraft.chest_minecart": "Товарна вагонетка",
  "item.minecraft.chicken": "Сурово пилешко месо",
  "item.minecraft.chicken_spawn_egg": "Яйце на кокошка",
  "item.minecraft.chorus_fruit": "Припевен плод",
  "item.minecraft.clay_ball": "Топка глина",
  "item.minecraft.clock": "Часовник",
  "item.minecraft.coal": "Каменни въглища",
  "item.minecraft.coast_armor_trim_smithing_template": "Ковачески шаблон",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Орнамент за броня - Бряг",
  "item.minecraft.cocoa_beans": "Какаови зърна",
  "item.minecraft.cod": "Сурова треска",
  "item.minecraft.cod_bucket": "Кофа с треска",
  "item.minecraft.cod_spawn_egg": "Яйце на треска",
  "item.minecraft.command_block_minecart": "Вагонетка с команден блок",
  "item.minecraft.compass": "Компас",
  "item.minecraft.cooked_beef": "Говежда пържола",
  "item.minecraft.cooked_chicken": "Печено пиле",
  "item.minecraft.cooked_cod": "Печена треска",
  "item.minecraft.cooked_mutton": "Сготвено агнешко",
  "item.minecraft.cooked_porkchop": "Печена свинска пържола",
  "item.minecraft.cooked_rabbit": "Сготвено заешко",
  "item.minecraft.cooked_salmon": "Сготвена сьомга",
  "item.minecraft.cookie": "Бисквитка",
  "item.minecraft.copper_axe": "Медна брадва",
  "item.minecraft.copper_boots": "Медни ботуши",
  "item.minecraft.copper_chestplate": "Меден нагръдник",
  "item.minecraft.copper_golem_spawn_egg": "Яйце на меден голем",
  "item.minecraft.copper_helmet": "Меден шлем",
  "item.minecraft.copper_hoe": "Медна мотика",
  "item.minecraft.copper_horse_armor": "Медна конска броня",
  "item.minecraft.copper_ingot": "Медно кюлче",
  "item.minecraft.copper_leggings": "Медни панталони",
  "item.minecraft.copper_nautilus_armor": "Медна наутилус броня",
  "item.minecraft.copper_nugget": "Меден къшей",
  "item.minecraft.copper_pickaxe": "Медна кирка",
  "item.minecraft.copper_shovel": "Медна лопата",
  "item.minecraft.copper_spear": "Медно копие",
  "item.minecraft.copper_sword": "Меден меч",
  "item.minecraft.cow_spawn_egg": "Яйце на крава",
  "item.minecraft.creaking_spawn_egg": "Яйце на скърцащ",
  "item.minecraft.creeper_banner_pattern": "Шаблон за знаме",
  "item.minecraft.creeper_banner_pattern.desc": "Фигура на крийпър",
  "item.minecraft.creeper_banner_pattern.new": "Шаблон за знаме - Creeper",
  "item.minecraft.creeper_spawn_egg": "Яйце на крийпър",
  "item.minecraft.crossbow": "Арбалет",
  "item.minecraft.crossbow.projectile": "Снаряд:",
  "item.minecraft.crossbow.projectile.multiple": "Снаряд: %s x %s\n",
  "item.minecraft.crossbow.projectile.single": "Снаряд: %s",
  "item.minecraft.cyan_bundle": "Синьо-зелен вързоп",
  "item.minecraft.cyan_dye": "Синьозелена боя",
  "item.minecraft.cyan_harness": "Цианова сбруя",
  "item.minecraft.danger_pottery_shard": "Парче керамика „Опасност“",
  "item.minecraft.danger_pottery_sherd": "Парче керамика „Опасност“",
  "item.minecraft.dark_oak_boat": "Лодка от черен дъб",
  "item.minecraft.dark_oak_chest_boat": "Лодка от черен дъб със сандък",
  "item.minecraft.debug_stick": "Пръчка на промяната",
  "item.minecraft.debug_stick.empty": "%s няма свойства",
  "item.minecraft.debug_stick.select": "беше избрано \"%s\" (%s)",
  "item.minecraft.debug_stick.update": "\"%s\" беше променено на %s",
  "item.minecraft.diamond": "Диамант",
  "item.minecraft.diamond_axe": "Диамантена брадва",
  "item.minecraft.diamond_boots": "Диамантени ботуши",
  "item.minecraft.diamond_chestplate": "Диамантен нагръдник",
  "item.minecraft.diamond_helmet": "Диамантен шлем",
  "item.minecraft.diamond_hoe": "Диамантена мотика",
  "item.minecraft.diamond_horse_armor": "Диамантена конска броня",
  "item.minecraft.diamond_leggings": "Диамантени панталони",
  "item.minecraft.diamond_nautilus_armor": "Диамантена наутилус броня",
  "item.minecraft.diamond_pickaxe": "Диамантена кирка",
  "item.minecraft.diamond_shovel": "Диамантена лопата",
  "item.minecraft.diamond_spear": "Диамантено копие",
  "item.minecraft.diamond_sword": "Диамантен меч",
  "item.minecraft.disc_fragment_5": "Фрагмент от диск",
  "item.minecraft.disc_fragment_5.desc": "Музикална плоча - 5",
  "item.minecraft.dolphin_spawn_egg": "Яйце на делфин",
  "item.minecraft.donkey_spawn_egg": "Яйце на магаре",
  "item.minecraft.dragon_breath": "Драконов дъх",
  "item.minecraft.dried_kelp": "Изсушени водорасли",
  "item.minecraft.drowned_spawn_egg": "Яйце на удавник",
  "item.minecraft.dune_armor_trim_smithing_template": "Ковачески шаблон",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Орнамент за броня - Дюна",
  "item.minecraft.echo_shard": "Ехо кристал",
  "item.minecraft.egg": "Яйце",
  "item.minecraft.elder_guardian_spawn_egg": "Яйце на възрастен пазител",
  "item.minecraft.elytra": "Криле",
  "item.minecraft.emerald": "Смарагд",
  "item.minecraft.enchanted_book": "Омагьосана книга",
  "item.minecraft.enchanted_golden_apple": "Омагьосана златна ябълка",
  "item.minecraft.end_crystal": "Кристал от Края",
  "item.minecraft.ender_dragon_spawn_egg": "Яйце на Дракон от Края",
  "item.minecraft.ender_eye": "Око на Края",
  "item.minecraft.ender_pearl": "Перла от Края",
  "item.minecraft.enderman_spawn_egg": "Яйце на ендърмен",
  "item.minecraft.endermite_spawn_egg": "Яйце на ендърмит",
  "item.minecraft.evoker_spawn_egg": "Яйце на призовател",
  "item.minecraft.experience_bottle": "Магическа колба",
  "item.minecraft.explorer_pottery_shard": "Парче керамика „Изследовател“",
  "item.minecraft.explorer_pottery_sherd": "Парче керамика „Изследовател“",
  "item.minecraft.eye_armor_trim_smithing_template": "Ковачески шаблон",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Орнамент за броня - Око",
  "item.minecraft.feather": "Перо",
  "item.minecraft.fermented_spider_eye": "Ферментирало око на паяк",
  "item.minecraft.field_masoned_banner_pattern": "Шаблон за знаме - Зид",
  "item.minecraft.filled_map": "Карта",
  "item.minecraft.fire_charge": "Огнен заряд",
  "item.minecraft.firework_rocket": "Фойерверк",
  "item.minecraft.firework_rocket.flight": "Продължителност на полета:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Звезда за фойерверк",
  "item.minecraft.firework_star.black": "Черно",
  "item.minecraft.firework_star.blue": "Синьо",
  "item.minecraft.firework_star.brown": "Кафяво",
  "item.minecraft.firework_star.custom_color": "По избор",
  "item.minecraft.firework_star.cyan": "Синьозелено",
  "item.minecraft.firework_star.fade_to": "Преливащо в",
  "item.minecraft.firework_star.flicker": "Блестящо",
  "item.minecraft.firework_star.gray": "Сиво",
  "item.minecraft.firework_star.green": "Зелено",
  "item.minecraft.firework_star.light_blue": "Светлосиньо",
  "item.minecraft.firework_star.light_gray": "Светлосиво",
  "item.minecraft.firework_star.lime": "Жълто-зелено",
  "item.minecraft.firework_star.magenta": "Пурпурно",
  "item.minecraft.firework_star.orange": "Оранжево",
  "item.minecraft.firework_star.pink": "Розово",
  "item.minecraft.firework_star.purple": "Лилаво",
  "item.minecraft.firework_star.red": "Червено",
  "item.minecraft.firework_star.shape": "Непозната форма",
  "item.minecraft.firework_star.shape.burst": "Взрив",
  "item.minecraft.firework_star.shape.creeper": "Крийпърообразно",
  "item.minecraft.firework_star.shape.large_ball": "Голяма топка",
  "item.minecraft.firework_star.shape.small_ball": "Малка топка",
  "item.minecraft.firework_star.shape.star": "Звездовидно",
  "item.minecraft.firework_star.trail": "Следа",
  "item.minecraft.firework_star.white": "Бяло",
  "item.minecraft.firework_star.yellow": "Жълто",
  "item.minecraft.fishing_rod": "Въдица",
  "item.minecraft.flint": "Кремък",
  "item.minecraft.flint_and_steel": "Запалка",
  "item.minecraft.flow_armor_trim_smithing_template": "Ковачески шаблон",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Орнамент за броня - Поток",
  "item.minecraft.flow_banner_pattern": "Шаблон за знаме",
  "item.minecraft.flow_banner_pattern.desc": "Поток",
  "item.minecraft.flow_banner_pattern.new": "Шаблон за знаме - Поток",
  "item.minecraft.flow_pottery_sherd": "Парче керамика „Поток“",
  "item.minecraft.flower_banner_pattern": "Шаблон за знаме",
  "item.minecraft.flower_banner_pattern.desc": "Фигура на цвете",
  "item.minecraft.flower_banner_pattern.new": "Шаблон за знаме - Цвете",
  "item.minecraft.flower_pot": "Саксия",
  "item.minecraft.fox_spawn_egg": "Яйце на лисица",
  "item.minecraft.friend_pottery_shard": "Парче керамика „Приятел“",
  "item.minecraft.friend_pottery_sherd": "Парче керамика „Приятел“",
  "item.minecraft.frog_spawn_egg": "Яйце на жаба",
  "item.minecraft.furnace_minecart": "Вагонетка с пещ",
  "item.minecraft.ghast_spawn_egg": "Яйце на гаст",
  "item.minecraft.ghast_tear": "Сълза на гаст",
  "item.minecraft.glass_bottle": "Стъкленица",
  "item.minecraft.glistering_melon_slice": "Блестящ резен диня",
  "item.minecraft.globe_banner_pattern": "Шаблон за знаме",
  "item.minecraft.globe_banner_pattern.desc": "Земно кълбо",
  "item.minecraft.globe_banner_pattern.new": "Шаблон за знаме - Глобус",
  "item.minecraft.glow_berries": "Светещи боровинки",
  "item.minecraft.glow_ink_sac": "Светещо мастило",
  "item.minecraft.glow_item_frame": "Светеща рамка",
  "item.minecraft.glow_squid_spawn_egg": "Яйце на светеща сепия",
  "item.minecraft.glowstone_dust": "Прах от сияещ камък",
  "item.minecraft.goat_horn": "Рог на коза",
  "item.minecraft.goat_spawn_egg": "Яйце на коза",
  "item.minecraft.gold_ingot": "Златно кюлче",
  "item.minecraft.gold_nugget": "Златен къшей",
  "item.minecraft.golden_apple": "Златна ябълка",
  "item.minecraft.golden_axe": "Златна брадва",
  "item.minecraft.golden_boots": "Златни ботуши",
  "item.minecraft.golden_carrot": "Златен морков",
  "item.minecraft.golden_chestplate": "Златен нагръдник",
  "item.minecraft.golden_helmet": "Златен шлем",
  "item.minecraft.golden_hoe": "Златна мотика",
  "item.minecraft.golden_horse_armor": "Златна конска броня",
  "item.minecraft.golden_leggings": "Златни панталони",
  "item.minecraft.golden_nautilus_armor": "Златна наутилус броня",
  "item.minecraft.golden_pickaxe": "Златна кирка",
  "item.minecraft.golden_shovel": "Златна лопата",
  "item.minecraft.golden_spear": "Златно копие",
  "item.minecraft.golden_sword": "Златен меч",
  "item.minecraft.gray_bundle": "Сив вързоп",
  "item.minecraft.gray_dye": "Сива боя",
  "item.minecraft.gray_harness": "Сива Сбруя",
  "item.minecraft.green_bundle": "Зелен вързоп",
  "item.minecraft.green_dye": "Зелена боя",
  "item.minecraft.green_harness": "Зелена сбруя",
  "item.minecraft.guardian_spawn_egg": "Яйце на пазител",
  "item.minecraft.gunpowder": "Барут",
  "item.minecraft.guster_banner_pattern": "Шаблон за знаме",
  "item.minecraft.guster_banner_pattern.desc": "Порив",
  "item.minecraft.guster_banner_pattern.new": "Шаблон за знаме - Вихър",
  "item.minecraft.guster_pottery_sherd": "Парче керамика „Порив“",
  "item.minecraft.happy_ghast_spawn_egg": "Яйце на Щастлив гаст",
  "item.minecraft.harness": "Сбруя",
  "item.minecraft.heart_of_the_sea": "Сърце на морето",
  "item.minecraft.heart_pottery_shard": "Парче керамика „Сърце“",
  "item.minecraft.heart_pottery_sherd": "Парче керамика „Сърце“",
  "item.minecraft.heartbreak_pottery_shard": "Парче керамика „Разбито сърце“",
  "item.minecraft.heartbreak_pottery_sherd": "Парче керамика „Разбито сърце“",
  "item.minecraft.hoglin_spawn_egg": "Яйце на Хоглин",
  "item.minecraft.honey_bottle": "Бутилка с мед",
  "item.minecraft.honeycomb": "Медена пита",
  "item.minecraft.hopper_minecart": "Вагонетка с фуния",
  "item.minecraft.horse_spawn_egg": "Яйце на кон",
  "item.minecraft.host_armor_trim_smithing_template": "Ковачески шаблон",
  "item.minecraft.host_armor_trim_smithing_template.new": "Орнамент за броня - Домакин",
  "item.minecraft.howl_pottery_shard": "Парче керамика „Вой“",
  "item.minecraft.howl_pottery_sherd": "Парче керамика „Вой“",
  "item.minecraft.husk_spawn_egg": "Яйце на изсъхнало зомби",
  "item.minecraft.ink_sac": "Мастило",
  "item.minecraft.iron_axe": "Желязна брадва",
  "item.minecraft.iron_boots": "Железни ботуши",
  "item.minecraft.iron_chestplate": "Железен нагръдник",
  "item.minecraft.iron_golem_spawn_egg": "Яйце на железен голем",
  "item.minecraft.iron_helmet": "Железен шлем",
  "item.minecraft.iron_hoe": "Желязна мотика",
  "item.minecraft.iron_horse_armor": "Желязна конска броня",
  "item.minecraft.iron_ingot": "Желязно кюлче",
  "item.minecraft.iron_leggings": "Железни панталони",
  "item.minecraft.iron_nautilus_armor": "Желязна наутилус броня",
  "item.minecraft.iron_nugget": "Железен къшей",
  "item.minecraft.iron_pickaxe": "Желязна кирка",
  "item.minecraft.iron_shovel": "Желязна лопата",
  "item.minecraft.iron_spear": "Желязно копие",
  "item.minecraft.iron_sword": "Железен меч",
  "item.minecraft.item_frame": "Рамка",
  "item.minecraft.jungle_boat": "Джунглова лодка",
  "item.minecraft.jungle_chest_boat": "Джунглова лодка със сандък",
  "item.minecraft.knowledge_book": "Книга на знанието",
  "item.minecraft.lapis_lazuli": "Лазурит",
  "item.minecraft.lava_bucket": "Кофа с лава",
  "item.minecraft.lead": "Каишка",
  "item.minecraft.leather": "Кожа",
  "item.minecraft.leather_boots": "Кожени ботуши",
  "item.minecraft.leather_chestplate": "Кожена туника",
  "item.minecraft.leather_helmet": "Кожена шапка",
  "item.minecraft.leather_horse_armor": "Кожена броня за кон",
  "item.minecraft.leather_leggings": "Кожени панталони",
  "item.minecraft.light_blue_bundle": "Светлосин вързоп",
  "item.minecraft.light_blue_dye": "Светлосиня боя",
  "item.minecraft.light_blue_harness": "Светлосиня сбруя",
  "item.minecraft.light_gray_bundle": "Светлосив вързоп",
  "item.minecraft.light_gray_dye": "Светлосива боя",
  "item.minecraft.light_gray_harness": "Светлосиива сбруя",
  "item.minecraft.lime_bundle": "Жълто-зелен вързоп",
  "item.minecraft.lime_dye": "Жълто-зеленa боя",
  "item.minecraft.lime_harness": "Лайм сбруя",
  "item.minecraft.lingering_potion": "Задържаща се отвара",
  "item.minecraft.lingering_potion.effect.awkward": "Задържаща се неловка отвара",
  "item.minecraft.lingering_potion.effect.empty": "Задържаща се неизмайсторима отвара",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Задържаща се отвара на огнената устойчивост",
  "item.minecraft.lingering_potion.effect.harming": "Задържаща се отвара на нараняването",
  "item.minecraft.lingering_potion.effect.healing": "Задържаща се отвара на лечението",
  "item.minecraft.lingering_potion.effect.infested": "Задържаща се отвара на заразяването",
  "item.minecraft.lingering_potion.effect.invisibility": "Задържаща се отвара на невидимостта",
  "item.minecraft.lingering_potion.effect.leaping": "Задържаща се отвара на скокливостта",
  "item.minecraft.lingering_potion.effect.levitation": "Задържаща се отвара на левитацията",
  "item.minecraft.lingering_potion.effect.luck": "Задържаща се отвара на късмета",
  "item.minecraft.lingering_potion.effect.mundane": "Задържаща се обикновена отвара",
  "item.minecraft.lingering_potion.effect.night_vision": "Задържаща се отвара на нощното виждане",
  "item.minecraft.lingering_potion.effect.oozing": "Задържаща се отвара на слузливостта",
  "item.minecraft.lingering_potion.effect.poison": "Задържаща се отвара на отравянето",
  "item.minecraft.lingering_potion.effect.regeneration": "Задържаща се отвара на регенерацията",
  "item.minecraft.lingering_potion.effect.slow_falling": "Задържаща се отвара на бавното падане",
  "item.minecraft.lingering_potion.effect.slowness": "Задържаща се отвара на забавянето",
  "item.minecraft.lingering_potion.effect.strength": "Задържаща се отвара на силата",
  "item.minecraft.lingering_potion.effect.swiftness": "Задържаща се отвара на скоростта",
  "item.minecraft.lingering_potion.effect.thick": "Задържаща се гъста отвара",
  "item.minecraft.lingering_potion.effect.turtle_master": "Задържаща се отвара на костенурковата мощ",
  "item.minecraft.lingering_potion.effect.water": "Задържаща се стъкленица с вода",
  "item.minecraft.lingering_potion.effect.water_breathing": "Задържаща се отвара на подводното дишане",
  "item.minecraft.lingering_potion.effect.weakness": "Задържаща се отвара на слабостта",
  "item.minecraft.lingering_potion.effect.weaving": "Задържаща се отвара на тъкане",
  "item.minecraft.lingering_potion.effect.wind_charged": "Задържаща се отвара на въздушно зареждане",
  "item.minecraft.llama_spawn_egg": "Яйце на лама",
  "item.minecraft.lodestone_compass": "Компас за магнитен камък",
  "item.minecraft.mace": "Боздуган",
  "item.minecraft.magenta_bundle": "Пурпурен вързоп",
  "item.minecraft.magenta_dye": "Пурпурна боя",
  "item.minecraft.magenta_harness": "Магентова сбруя",
  "item.minecraft.magma_cream": "Магмен крем",
  "item.minecraft.magma_cube_spawn_egg": "Яйце на магмен куб",
  "item.minecraft.mangrove_boat": "Мангрова лодка",
  "item.minecraft.mangrove_chest_boat": "Мангрова лодка със сандък",
  "item.minecraft.map": "Празна карта",
  "item.minecraft.melon_seeds": "Динени семена",
  "item.minecraft.melon_slice": "Резен диня",
  "item.minecraft.milk_bucket": "Кофа с мляко",
  "item.minecraft.minecart": "Вагонетка",
  "item.minecraft.miner_pottery_shard": "Парче керамика „Миньор“",
  "item.minecraft.miner_pottery_sherd": "Парче керамика „Миньор“",
  "item.minecraft.mojang_banner_pattern": "Шаблон за знаме",
  "item.minecraft.mojang_banner_pattern.desc": "Нещо",
  "item.minecraft.mojang_banner_pattern.new": "Шаблон за знаме - Нещо",
  "item.minecraft.mooshroom_spawn_egg": "Яйце на муухоморка",
  "item.minecraft.mourner_pottery_shard": "Парче керамика „Скръбник“",
  "item.minecraft.mourner_pottery_sherd": "Парче керамика „Скръб“",
  "item.minecraft.mule_spawn_egg": "Яйце на муле",
  "item.minecraft.mushroom_stew": "Гъбена супа",
  "item.minecraft.music_disc_11": "Музикална плоча",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Музикална плоча",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Музикална плоча",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Музикална плоча",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Музикална плоча",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Музикална плоча",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Музикална плоча",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Музикална плоча",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (Музикална кутия)",
  "item.minecraft.music_disc_far": "Музикална плоча",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Музикален плоча",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Музикална плоча",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Музикална плоча",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Музикална плоча",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "Музикална плоча",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Музикална плоча",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Музикална плоча",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Музикална плоча",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Музикална плоча",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Музикална плоча",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Музикална плоча",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Музикална плоча",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Сурово агнешко",
  "item.minecraft.name_tag": "Каишка с име",
  "item.minecraft.nautilus_shell": "Черупка на наутилус",
  "item.minecraft.nautilus_spawn_egg": "Яйце на наутилус",
  "item.minecraft.nether_brick": "Тухла от Недъра",
  "item.minecraft.nether_star": "Звезда от Недъра",
  "item.minecraft.nether_wart": "Брадавица от Недъра",
  "item.minecraft.netherite_axe": "Недърайт брадва",
  "item.minecraft.netherite_boots": "Недърайт ботуши",
  "item.minecraft.netherite_chestplate": "Недърайт нагръдник",
  "item.minecraft.netherite_helmet": "Недърайт шлем",
  "item.minecraft.netherite_hoe": "Недърайт мотика",
  "item.minecraft.netherite_horse_armor": "Недеритена броня на кон",
  "item.minecraft.netherite_ingot": "Недърайт кюлче",
  "item.minecraft.netherite_leggings": "Недърайт панталони",
  "item.minecraft.netherite_nautilus_armor": "Недърайт наутилус броня",
  "item.minecraft.netherite_pickaxe": "Недърайт кирка",
  "item.minecraft.netherite_scrap": "Късче Недърайт",
  "item.minecraft.netherite_shovel": "Недърайт лопата",
  "item.minecraft.netherite_spear": "Недърайт копие",
  "item.minecraft.netherite_sword": "Недърайт меч",
  "item.minecraft.netherite_upgrade_smithing_template": "Ковачески шаблон",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Надграждане с Недърайт",
  "item.minecraft.oak_boat": "Дъбова лодка",
  "item.minecraft.oak_chest_boat": "Дъбова лодка със сандък",
  "item.minecraft.ocelot_spawn_egg": "Яйце на оцелот",
  "item.minecraft.ominous_bottle": "Зловеща бутилка",
  "item.minecraft.ominous_trial_key": "Зловещ изпитателен ключ",
  "item.minecraft.orange_bundle": "Оранжев вързоп",
  "item.minecraft.orange_dye": "Оранжева боя",
  "item.minecraft.orange_harness": "Оранжева сбруя",
  "item.minecraft.painting": "Картина",
  "item.minecraft.pale_oak_boat": "Лодка от блед дъб",
  "item.minecraft.pale_oak_chest_boat": "Лодка от блед дъб със сандък",
  "item.minecraft.panda_spawn_egg": "Яйце на панда",
  "item.minecraft.paper": "Хартия",
  "item.minecraft.parched_spawn_egg": "Яйце на пресъхнал скелет",
  "item.minecraft.parrot_spawn_egg": "Яйце на папагал",
  "item.minecraft.phantom_membrane": "Ципа на призрачна птица",
  "item.minecraft.phantom_spawn_egg": "Яйце на призрачна птица",
  "item.minecraft.pig_spawn_egg": "Яйце на прасе",
  "item.minecraft.piglin_banner_pattern": "Шаблон за знаме",
  "item.minecraft.piglin_banner_pattern.desc": "Зурла",
  "item.minecraft.piglin_banner_pattern.new": "Шаблон за знаме - Зурла",
  "item.minecraft.piglin_brute_spawn_egg": "Яйце на свиреп пиглин",
  "item.minecraft.piglin_spawn_egg": "Яйце на пиглин",
  "item.minecraft.pillager_spawn_egg": "Яйце на разбойник",
  "item.minecraft.pink_bundle": "Розов вързоп",
  "item.minecraft.pink_dye": "Розова боя",
  "item.minecraft.pink_harness": "Розова сбруя",
  "item.minecraft.pitcher_plant": "Стомнично цвете",
  "item.minecraft.pitcher_pod": "Шушулка на стомнично цвете",
  "item.minecraft.plenty_pottery_shard": "Парче керамика „Изобилие“",
  "item.minecraft.plenty_pottery_sherd": "Парче керамика „Изобилие“",
  "item.minecraft.poisonous_potato": "Отровен картоф",
  "item.minecraft.polar_bear_spawn_egg": "Яйце на бяла мечка",
  "item.minecraft.popped_chorus_fruit": "Пукнат припевен плод",
  "item.minecraft.porkchop": "Сурова свинска пържола",
  "item.minecraft.potato": "Картоф",
  "item.minecraft.potion": "Отвара",
  "item.minecraft.potion.effect.awkward": "Неловка отвара",
  "item.minecraft.potion.effect.empty": "Неизмайсторима отвара",
  "item.minecraft.potion.effect.fire_resistance": "Отвара на огнената устойчивост",
  "item.minecraft.potion.effect.harming": "Отвара на нараняването",
  "item.minecraft.potion.effect.healing": "Отвара на лечението",
  "item.minecraft.potion.effect.infested": "Отвара на заразяването",
  "item.minecraft.potion.effect.invisibility": "Отвара на невидимостта",
  "item.minecraft.potion.effect.leaping": "Отвара на скокливостта",
  "item.minecraft.potion.effect.levitation": "Отвара на левитацията",
  "item.minecraft.potion.effect.luck": "Отвара на късмета",
  "item.minecraft.potion.effect.mundane": "Обикновена отвара",
  "item.minecraft.potion.effect.night_vision": "Отвара на нощното виждане",
  "item.minecraft.potion.effect.oozing": "Отвара на слузливостта",
  "item.minecraft.potion.effect.poison": "Отвара на отравянето",
  "item.minecraft.potion.effect.regeneration": "Отвара на регенерацията",
  "item.minecraft.potion.effect.slow_falling": "Отвара на бавното падане",
  "item.minecraft.potion.effect.slowness": "Отвара на забавянето",
  "item.minecraft.potion.effect.strength": "Отвара на силата",
  "item.minecraft.potion.effect.swiftness": "Отвара на скоростта",
  "item.minecraft.potion.effect.thick": "Гъста отвара",
  "item.minecraft.potion.effect.turtle_master": "Отвара на костенурковата мощ",
  "item.minecraft.potion.effect.water": "Бутилка с вода",
  "item.minecraft.potion.effect.water_breathing": "Отвара на подводното дишане",
  "item.minecraft.potion.effect.weakness": "Отвара на слабостта",
  "item.minecraft.potion.effect.weaving": "Отвара на тъкане",
  "item.minecraft.potion.effect.wind_charged": "Отвара на въздушно зареждане",
  "item.minecraft.pottery_shard_archer": "Керамика на стрелец",
  "item.minecraft.pottery_shard_arms_up": "Парче керамика „Вдигнати ръце“",
  "item.minecraft.pottery_shard_prize": "Парче керамика „Награда“",
  "item.minecraft.pottery_shard_skull": "Парче керамика „Череп“",
  "item.minecraft.powder_snow_bucket": "Кофа с пухкав сняг",
  "item.minecraft.prismarine_crystals": "Призмаринови кристали",
  "item.minecraft.prismarine_shard": "Призмаринов къшей",
  "item.minecraft.prize_pottery_shard": "Парче керамика „Награда“",
  "item.minecraft.prize_pottery_sherd": "Парче керамика „Награда“",
  "item.minecraft.pufferfish": "Риба балон",
  "item.minecraft.pufferfish_bucket": "Кофа с риба балон",
  "item.minecraft.pufferfish_spawn_egg": "Яйце на риба балон",
  "item.minecraft.pumpkin_pie": "Тиквен пай",
  "item.minecraft.pumpkin_seeds": "Тиквени семена",
  "item.minecraft.purple_bundle": "Лилав вързоп",
  "item.minecraft.purple_dye": "Лилава боя",
  "item.minecraft.purple_harness": "Лилава сбруя",
  "item.minecraft.quartz": "Кварц от Недъра",
  "item.minecraft.rabbit": "Сурово заешко",
  "item.minecraft.rabbit_foot": "Заешко краче",
  "item.minecraft.rabbit_hide": "Заешка кожа",
  "item.minecraft.rabbit_spawn_egg": "Яйце на заек",
  "item.minecraft.rabbit_stew": "Заешка яхния",
  "item.minecraft.raiser_armor_trim_smithing_template": "Ковачески шаблон",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Орнамент за броня - Островръх",
  "item.minecraft.ravager_spawn_egg": "Яйце на опустошител",
  "item.minecraft.raw_copper": "Необработена мед",
  "item.minecraft.raw_gold": "Необработено злато",
  "item.minecraft.raw_iron": "Необработено желязо",
  "item.minecraft.recovery_compass": "Възвръщащ компас",
  "item.minecraft.red_bundle": "Червен вързоп",
  "item.minecraft.red_dye": "Червена боя",
  "item.minecraft.red_harness": "Червена сбруя",
  "item.minecraft.redstone": "Червенокаменен прах",
  "item.minecraft.resin_brick": "Тухла от смола",
  "item.minecraft.resin_clump": "Къс смола",
  "item.minecraft.rib_armor_trim_smithing_template": "Ковачески шаблон",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Орнамент за броня - Ребро",
  "item.minecraft.rotten_flesh": "Гнила плът",
  "item.minecraft.saddle": "Седло",
  "item.minecraft.salmon": "Сурова сьомга",
  "item.minecraft.salmon_bucket": "Кофа със сьомга",
  "item.minecraft.salmon_spawn_egg": "Яйце на сьомга",
  "item.minecraft.scrape_pottery_sherd": "Парче керамика „Остърган“",
  "item.minecraft.scute": "Скут",
  "item.minecraft.sentry_armor_trim_smithing_template": "Ковачески шаблон",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Орнамент за броня - Страж",
  "item.minecraft.shaper_armor_trim_smithing_template": "Ковачески шаблон",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Орнамент за броня - Зигзаг",
  "item.minecraft.sheaf_pottery_shard": "Парче керамика „Сноп“",
  "item.minecraft.sheaf_pottery_sherd": "Парче керамика „Сноп“",
  "item.minecraft.shears": "Ножици",
  "item.minecraft.sheep_spawn_egg": "Яйце на овца",
  "item.minecraft.shelter_pottery_shard": "Парче керамика „Подслон“",
  "item.minecraft.shelter_pottery_sherd": "Парче керамика „Подслон“",
  "item.minecraft.shield": "Щит",
  "item.minecraft.shield.black": "Черен щит",
  "item.minecraft.shield.blue": "Син щит",
  "item.minecraft.shield.brown": "Кафяв щит",
  "item.minecraft.shield.cyan": "Синьозелен щит",
  "item.minecraft.shield.gray": "Сив щит",
  "item.minecraft.shield.green": "Зелен щит",
  "item.minecraft.shield.light_blue": "Светлосин щит",
  "item.minecraft.shield.light_gray": "Светлосив щит",
  "item.minecraft.shield.lime": "Жълто-зелен щит",
  "item.minecraft.shield.magenta": "Пурпурен щит",
  "item.minecraft.shield.orange": "Оранжев щит",
  "item.minecraft.shield.pink": "Розов щит",
  "item.minecraft.shield.purple": "Лилав щит",
  "item.minecraft.shield.red": "Червен щит",
  "item.minecraft.shield.white": "Бял щит",
  "item.minecraft.shield.yellow": "Жълт щит",
  "item.minecraft.shulker_shell": "Черупка на шулкър",
  "item.minecraft.shulker_spawn_egg": "Яйце на шулкър",
  "item.minecraft.sign": "Табела",
  "item.minecraft.silence_armor_trim_smithing_template": "Ковачески шаблон",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Орнамент за броня - Тишина",
  "item.minecraft.silverfish_spawn_egg": "Яйце на люспеница",
  "item.minecraft.skeleton_horse_spawn_egg": "Яйце на скелетен кон",
  "item.minecraft.skeleton_spawn_egg": "Яйце на скелет",
  "item.minecraft.skull_banner_pattern": "Шаблон за знаме",
  "item.minecraft.skull_banner_pattern.desc": "Фигура на череп",
  "item.minecraft.skull_banner_pattern.new": "Шаблон за знаме - Череп",
  "item.minecraft.skull_pottery_shard": "Парче керамика „Череп“",
  "item.minecraft.skull_pottery_sherd": "Парче керамика „Череп“",
  "item.minecraft.slime_ball": "Топка слуз",
  "item.minecraft.slime_spawn_egg": "Яйце на слуз",
  "item.minecraft.smithing_template": "Ковачески шаблон",
  "item.minecraft.smithing_template.applies_to": "Отговаря на:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Добави кюлче или кристал",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Броня",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Добави парче броня",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Кюлчета и Кристали от Края",
  "item.minecraft.smithing_template.ingredients": "Съставки:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Добавете Недърайт кюлче",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Диамантено оборудване",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Добавете диамантена броня, оръжие или инструмент",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Недърайт кюлче",
  "item.minecraft.smithing_template.upgrade": "Надграждане: ",
  "item.minecraft.sniffer_spawn_egg": "Яйце на Снифър",
  "item.minecraft.snort_pottery_shard": "Изсумтя керамика чиреп",
  "item.minecraft.snort_pottery_sherd": "Парче керамика „Сумтене“",
  "item.minecraft.snout_armor_trim_smithing_template": "Ковачески шаблон",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Орнамент за броня - Зурла",
  "item.minecraft.snow_golem_spawn_egg": "Яйце на снежен голем",
  "item.minecraft.snowball": "Снежна топка",
  "item.minecraft.spectral_arrow": "Призрачна стрела",
  "item.minecraft.spider_eye": "Око на паяк",
  "item.minecraft.spider_spawn_egg": "Яйце на паяк",
  "item.minecraft.spire_armor_trim_smithing_template": "Ковачески шаблон",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Орнамент за броня - Островръх",
  "item.minecraft.splash_potion": "Разплискваща се отвара",
  "item.minecraft.splash_potion.effect.awkward": "Неловка разплискваща се отвара",
  "item.minecraft.splash_potion.effect.empty": "Разплискваща се неизмайсторима отвара",
  "item.minecraft.splash_potion.effect.fire_resistance": "Разплискваща се отвара на огнената устойчивост",
  "item.minecraft.splash_potion.effect.harming": "Разплискваща се отвара на нараняването",
  "item.minecraft.splash_potion.effect.healing": "Разплискваща се отвара на заздравяването",
  "item.minecraft.splash_potion.effect.infested": "Разплискваща се отвара на заразяването",
  "item.minecraft.splash_potion.effect.invisibility": "Разплискваща се отвара на невидимостта",
  "item.minecraft.splash_potion.effect.leaping": "Разплискваща се отвара на скокливостта",
  "item.minecraft.splash_potion.effect.levitation": "Разплискваща се отвара на левитацията",
  "item.minecraft.splash_potion.effect.luck": "Разплискваща се отвара на късмета",
  "item.minecraft.splash_potion.effect.mundane": "Обикновена разплискваща се отвара",
  "item.minecraft.splash_potion.effect.night_vision": "Разплискваща се отвара на нощното виждане",
  "item.minecraft.splash_potion.effect.oozing": "Разплискваща се отвара на слузливостта",
  "item.minecraft.splash_potion.effect.poison": "Разплискваща се отвара на отравянето",
  "item.minecraft.splash_potion.effect.regeneration": "Разплискваща се отвара на регенерацията",
  "item.minecraft.splash_potion.effect.slow_falling": "Разплискваща се отвара на бавното падане",
  "item.minecraft.splash_potion.effect.slowness": "Разплискваща се отвара на забавянето",
  "item.minecraft.splash_potion.effect.strength": "Разплискваща се отвара на силата",
  "item.minecraft.splash_potion.effect.swiftness": "Разплискваща се отвара на скоростта",
  "item.minecraft.splash_potion.effect.thick": "Гъста разплискваща се отвара",
  "item.minecraft.splash_potion.effect.turtle_master": "Разплискваща се отвара на костенурковата мощ",
  "item.minecraft.splash_potion.effect.water": "Разплискваща се бутилка с вода",
  "item.minecraft.splash_potion.effect.water_breathing": "Разплискваща се отвара на подводното дишане",
  "item.minecraft.splash_potion.effect.weakness": "Разплискваща се отвара на слабостта",
  "item.minecraft.splash_potion.effect.weaving": "Разплискваща се отвара на тъкане",
  "item.minecraft.splash_potion.effect.wind_charged": "Разплискваща се отвара на въздушно зареждане",
  "item.minecraft.spruce_boat": "Смърчова лодка",
  "item.minecraft.spruce_chest_boat": "Смърчова лодка със сандък",
  "item.minecraft.spyglass": "Далекоглед",
  "item.minecraft.squid_spawn_egg": "Яйце на сепия",
  "item.minecraft.stick": "Пръчка",
  "item.minecraft.stone_axe": "Каменна брадва",
  "item.minecraft.stone_hoe": "Каменна мотика",
  "item.minecraft.stone_pickaxe": "Каменна кирка",
  "item.minecraft.stone_shovel": "Каменна лопата",
  "item.minecraft.stone_spear": "Каменно копие",
  "item.minecraft.stone_sword": "Каменен меч",
  "item.minecraft.stray_spawn_egg": "Яйце на скелет скитник",
  "item.minecraft.strider_spawn_egg": "Яйце на страйдър",
  "item.minecraft.string": "Връв",
  "item.minecraft.sugar": "Захар",
  "item.minecraft.suspicious_stew": "Подозрителна яхния",
  "item.minecraft.sweet_berries": "Сладки горски плодове",
  "item.minecraft.tadpole_bucket": "Кофа с попова лъжичка",
  "item.minecraft.tadpole_spawn_egg": "Яйце на попова лъжичка",
  "item.minecraft.tide_armor_trim_smithing_template": "Ковачески шаблон",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Орнамент за броня - Прилив",
  "item.minecraft.tipped_arrow": "Стрела с връх",
  "item.minecraft.tipped_arrow.effect.awkward": "Стрела с връх",
  "item.minecraft.tipped_arrow.effect.empty": "Неизмайсторима стрела с връх",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Стрела на огнената устойчивост",
  "item.minecraft.tipped_arrow.effect.harming": "Стрела на нараняването",
  "item.minecraft.tipped_arrow.effect.healing": "Стрела на заздравяването",
  "item.minecraft.tipped_arrow.effect.infested": "Стрела на заразяването",
  "item.minecraft.tipped_arrow.effect.invisibility": "Стрела на невидимостта",
  "item.minecraft.tipped_arrow.effect.leaping": "Стрела на скокливостта",
  "item.minecraft.tipped_arrow.effect.levitation": "Стрела на левитацията",
  "item.minecraft.tipped_arrow.effect.luck": "Стрела на късмета",
  "item.minecraft.tipped_arrow.effect.mundane": "Стрела с връх",
  "item.minecraft.tipped_arrow.effect.night_vision": "Стрела на нощното виждане",
  "item.minecraft.tipped_arrow.effect.oozing": "Стрела на слузливостта",
  "item.minecraft.tipped_arrow.effect.poison": "Стрела на отравянето",
  "item.minecraft.tipped_arrow.effect.regeneration": "Стрела на регенерацията",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Стрела на бавното падане",
  "item.minecraft.tipped_arrow.effect.slowness": "Стрела на забавянето",
  "item.minecraft.tipped_arrow.effect.strength": "Стрела на силата",
  "item.minecraft.tipped_arrow.effect.swiftness": "Стрела на скоростта",
  "item.minecraft.tipped_arrow.effect.thick": "Стрела с връх",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Стрела на костенурковата мощ",
  "item.minecraft.tipped_arrow.effect.water": "Стрела на плискането",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Стрела на подводното дишане",
  "item.minecraft.tipped_arrow.effect.weakness": "Стрела на слабостта",
  "item.minecraft.tipped_arrow.effect.weaving": "Стрела на тъкане",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Стрела на въздушно зареждане",
  "item.minecraft.tnt_minecart": "Вагонетка с динамит",
  "item.minecraft.torchflower_seeds": "Семена на факлено цвете",
  "item.minecraft.totem_of_undying": "Тотем на безсмъртието",
  "item.minecraft.trader_llama_spawn_egg": "Яйце на лама на търговец",
  "item.minecraft.trial_key": "Изпитателен ключ",
  "item.minecraft.trident": "Тризъбец",
  "item.minecraft.tropical_fish": "Тропическа риба",
  "item.minecraft.tropical_fish_bucket": "Кофа с тропическа риба",
  "item.minecraft.tropical_fish_spawn_egg": "Яйце на тропическа риба",
  "item.minecraft.turtle_helmet": "Черупка на костенурка",
  "item.minecraft.turtle_scute": "Черупка от костенурка",
  "item.minecraft.turtle_spawn_egg": "Яйце на костенурка",
  "item.minecraft.vex_armor_trim_smithing_template": "Ковачески шаблон",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Орнамент за броня - Дразняч",
  "item.minecraft.vex_spawn_egg": "Яйце на дразняч",
  "item.minecraft.villager_spawn_egg": "Яйце на селянин",
  "item.minecraft.vindicator_spawn_egg": "Яйце на бранител",
  "item.minecraft.wandering_trader_spawn_egg": "Яйце на странстващ търговец",
  "item.minecraft.ward_armor_trim_smithing_template": "Ковачески шаблон",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Орнамент за броня - Надзирател",
  "item.minecraft.warden_spawn_egg": "Яйце на Надзирател",
  "item.minecraft.warped_fungus_on_a_stick": "Шантава гъба на пръчка",
  "item.minecraft.water_bucket": "Кофа с вода",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Ковачески шаблон",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Орнамент за броня - Търсач",
  "item.minecraft.wheat": "Пшеница",
  "item.minecraft.wheat_seeds": "Пшеничени семена",
  "item.minecraft.white_bundle": "Бял вързоп",
  "item.minecraft.white_dye": "Бяла боя",
  "item.minecraft.white_harness": "Бяла сбруя",
  "item.minecraft.wild_armor_trim_smithing_template": "Ковачески шаблон",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Орнамент за броня - Див",
  "item.minecraft.wind_charge": "Въздушен заряд",
  "item.minecraft.witch_spawn_egg": "Яйце на вещица",
  "item.minecraft.wither_skeleton_spawn_egg": "Яйце на yидър-скелет",
  "item.minecraft.wither_spawn_egg": "Яйце на Чрезнеещ",
  "item.minecraft.wolf_armor": "Вълча броня",
  "item.minecraft.wolf_spawn_egg": "Яйце на вълк",
  "item.minecraft.wooden_axe": "Дървена брадва",
  "item.minecraft.wooden_hoe": "Дървена мотика",
  "item.minecraft.wooden_pickaxe": "Дървена кирка",
  "item.minecraft.wooden_shovel": "Дървена лопата",
  "item.minecraft.wooden_spear": "Дървено копие",
  "item.minecraft.wooden_sword": "Дървен меч",
  "item.minecraft.writable_book": "Книга и перо",
  "item.minecraft.written_book": "Написана книга",
  "item.minecraft.yellow_bundle": "Жълт вързоп",
  "item.minecraft.yellow_dye": "Жълта боя",
  "item.minecraft.yellow_harness": "Жълта сбруя",
  "item.minecraft.zoglin_spawn_egg": "Яйце на зоглин",
  "item.minecraft.zombie_horse_spawn_egg": "Яйце на кон зомби",
  "item.minecraft.zombie_nautilus_spawn_egg": "Яйце на наутилус зомби",
  "item.minecraft.zombie_spawn_egg": "Яйце на зомби",
  "item.minecraft.zombie_villager_spawn_egg": "Яйце на селянин зомби",
  "item.minecraft.zombified_piglin_spawn_egg": "Яйце на зомби пиглин"
}
export const bg_bg = items; 
